import templateMain from './views/report-view.html';
import typeOneMarkComponentTemplate from './views/generated-templates/type-1-mark.html';
import typeTwoMarkComponentTemplate from './views/generated-templates/type-2-mark.html';
import reportCardApprovalPopup from './views/report-approval-pop-up.html';
import typeThreeSubSkillComponentTemplate from './views/generated-templates/type-3-sub_skill.html';
import typeOneGradeComponentTemplate from './views/generated-templates/type-1-grade.html';
import periodicTestDeafaultHFTemplate from './views/generated-templates/periodic-test-hf.html';
import periodicTestDeafaultANNUALTemplate from './views/generated-templates/periodic-test-annual.html';
import skill_onlyTemplate from './views/generated-templates/skill_only.html';
import typeFourMarkTemplate from './views/generated-templates/type-4-mark.html';
import typeFourAnnualTemplate from './views/generated-templates/type-4-annual.html';
import periodicTestDeafaultHFTwoTemplate from './views/generated-templates/periodic-test-hf-2.html';
import periodicTestDefaultAnnualTwoTemplate from './views/generated-templates/periodic-test-annual-two.html';
import hssTemplate from './views/generated-templates/hss.html';
import cbse_hssTemplate from './views/generated-templates/cbse_hss.html';
import termOneHalfYearlyTemplate from './views/generated-templates/term1halfyearly.html';
import kbHssTermOneHalfYearlyTemplate from './views/generated-templates/kbhfhss.html';
import grade9Template from './views/generated-templates/grade-9-annual.html';
import grade1_8AnnTemplate from './views/generated-templates/grade-1_8-annual.html';
import annualCbsehssTEMPLATE from './views/generated-templates/annual_cbse_hss.html'
import nineAnnualOnlyTemplate from "./views/generated-templates/term-annual-only.html"
import KB_annual_Template from './views/generated-templates/kb_hss_annual.html';
import KB_PT_HF_template from './views/generated-templates/periodic-test-hf-kb.html';
import CALICUT_HF_EXAM from './views/generated-templates/hf1-exam.html';
import reportCardValidationPopup from './views/report-card-edit-validation-popup.html';

import type_5_9_10_template from './views/generated-templates/type5_9_10_grade_term1.html';
import type_5_9_10_templateTerm2 from './views/generated-templates/type5_9_10_grade_term2.html';


import type_5_6_8_Term1_template from './views/generated-templates/type5_6_8_grade_term1.html';
import type_5_6_8_Term2_template from './views/generated-templates/type5_6_8_grade_term2.html';
import type_5_6_7_Term1_template from './views/generated-templates/type5_6_7_grade_term1.html';
import type_7_1_2_Term1_template from './views/generated-templates/type7_1_2_grade_term1.html';
import type_6_6_7_Term1_template from './views/generated-templates/type6_6_7_grade_term1.html';
// import type_aln_1_2_Term1_template from './views/generated-templates/typealn_1_2_grade_term1.html';
import type_5_3_5_Term1_template from './views/generated-templates/type5_3_5_grade_term1.html';
import type_5_8_Term1_template from './views/generated-templates/type5_8_grade_term1.html';
import type_5_1_2_Term1_template from './views/generated-templates/type5_1_2_grade_term1.html';
import type_6_1_2_Term1_template from './views/generated-templates/type6_1_2_grade_term1.html';
import type_6_3_5_Term1_template from './views/generated-templates/type6_3_5_grade_term1.html';
import type_5_1_5_Term1_template from './views/generated-templates/type5_1_5_grade_term1.html';
import type_5_1_5_Term2_template from './views/generated-templates/type5_1_5_grade_term2.html';
// import type_5_3_5_Term1_template from './views/generated-templates/type5_1_5_grade_term2.html';
// import type_5_1_5_Term3_template from './views/generated-templates/type5_1_5_grade_term3.html';
import type_5_10_Kb_Term1_template from './views/generated-templates/type5_KB_10_grade_term1.html';
import type_5_10_Kb_Term2_template from './views/generated-templates/type5_KB_10_grade_term2.html';
import type_5_8_9_Kb_Term1_template from './views/generated-templates/type5_KB_8_9_grade_term1.html';
import type_5_8_9_Kb_Term2_template from './views/generated-templates/type5_KB_8_9_grade_term2.html';
import type_5_8_9_Kb_Term3_template from './views/generated-templates/type5_KB_8_9_grade_term3.html';


import type_6_model_exam_1_template from './views/generated-templates/type_6_model_exam_1.html';
import type_6_model_exam_1nineten_template from './views/generated-templates/type_6_model_exam_1_nineten.html';
import type_6_model_exam_2nineten_template from './views/generated-templates/type_6_model_exam_2_nineten.html';
import type_6_model_exam_2_template from './views/generated-templates/type_6_model_exam_2.html';
import type_6_model_annualexam_2_template from './views/generated-templates/type_6_model_annualexam_2.html';

import type_7calicut_annual_template from './views/generated-templates/calicut_annual.html';

import type9_cbse_pt1_template from './views/generated-templates/type9_cbse_pt1.html';
import type9_cbse_hf1_template from './views/generated-templates/type9_term1_hf.html';
import type9_cbse_term2_ae_template from './views/generated-templates/type9_term2_ae.html';
import type9_grade12term2_ae_template from './views/generated-templates/type9_grade12term2_ae.html';
import type9_kb_unit_test1_template from './views/generated-templates/type9_kb_unit_test1.html';
import type9_kbterm1_hf_template from './views/generated-templates/type9_kbterm1_hf.html';
import type9_kbterm2_template from './views/generated-templates/type9_kbterm2.html';
import type9_kbterm3_template from './views/generated-templates/type9_kbterm3.html';
import type12term1cbseTemplate from './views/generated-templates/type12_termcbse.html'
import type12NineTentermcbseTemplate from './views/generated-templates/type12_ninetentermcbse.html'
import eltReportTemplate from './views/generated-templates/elt_report.html'
import type20_KB_10_grade_term1Temp from './views/generated-templates/type20_KB_10_grade_term1.html'
import type20term1cbseTemplate from './views/generated-templates/type20_termcbse.html'
import type20term1cbse18Template from './views/generated-templates/type20_termcbse18.html'
import type20term2cbseTemplate from './views/generated-templates/type20_term2cbse.html'
import type20_term2cbse18Template from './views/generated-templates/type20_term2cbse18.html'
import type20_KB_10_grade_term2Temp from './views/generated-templates/type20_KB_10_grade_term2.html'
import type_30_89Kb_Term1_template from './views/generated-templates/type30_KB_grade_term1.html';
import type_30_89Kb_Term2_template from './views/generated-templates/type30_KB_grade_term2.html';
import type_30_89Kb_Term3_template from './views/generated-templates/type30_KB_grade_term3.html';
import type_30_89Kb_Term1_new26_template from './views/generated-templates/type30_KB_grade_term1_new26.html';
import type_30_89Kb_Term2_new26_template from './views/generated-templates/type30_KB_grade_term2_new26.html';
import type_30_89Kb_Term3_new26_template from './views/generated-templates/type30_KB_grade_term3_new26.html';
import type8to10_termcbseTemplate from './views/generated-templates/type8to10_termcbse.html'
import typetermcbse_8to10Template from './views/generated-templates/typetermcbse_8to10.html'
import type6to7_alncbseTemplate from './views/generated-templates/type6to7_alncbse.html'
import type6to7_tcscbseTemplate from './views/generated-templates/type6to7_tcscbse.html'
import type3to5_tcscbseTemplate from './views/generated-templates/type3to5_tcscbse.html'
import type3to5_alncbseTemplate from './views/generated-templates/type3to5_alncbse.html'
import type1to2_tcscbseTemplate from './views/generated-templates/type1to2_tcscbse.html'

import type_10_KB_Term1_template from './views/generated-templates/type10_KB_grade_term1.html';
import type_10_KB_Term2_template from './views/generated-templates/type10_KB_grade_term2.html';
import type_10_11_12_KB_Term1_template from './views/generated-templates/type10_KB_grade11_12_term1.html';
import type_10_11_12_KB_Term2_template from './views/generated-templates/type10_KB_grade11_12_term2.html';
import type_10_11_12_KB_Term1_new26_template from './views/generated-templates/type10_KB_grade11_12_term1_new26.html';
import type_10_11_12_KB_Term2_new26_template from './views/generated-templates/type10_KB_grade11_12_term2_new26.html';
import type02grade_11_ScienceTemplate from './views/generated-templates/type02grade_11_science.html'
import type02grade_11_ScienceT2Template from './views/generated-templates/type02grade_11_sciencet2.html'
import type02grade_12_ScienceTemplate from './views/generated-templates/type02grade_12_science.html'
 import type02grade_12_ScienceT2Template from './views/generated-templates/type02grade_12_sciencet2.html'


 import type_5_3_5_Term2_template from './views/generated-templates/type5_3_5_grade_term2.html'
 import  type_6_6_7_Term2_template from './views/generated-templates/type6_6_7_grade_term2.html'
 import type8to10_term2cbseTemplate from './views/generated-templates/type8to10_termcbseterm2.html'
 import type_5_1_2_Term2_template from './views/generated-templates/type5_1_2_grade_term2.html';
 import type_1to2shjcbset2_template from './views/generated-templates/type1to2shjcbset2.html'
 import type1to2_tcscbseterm2Template from './views/generated-templates/type1to2_tcscbse_term2.html'
 import type6to7_tcscbseterm2Template from './views/generated-templates/type6to7_tcscbseterm2.html'
 import type3to5_tcscbseterm2Template from './views/generated-templates/type3to5_tcscbseterm2.html'
 import type_6_3_5_Term2_template from './views/generated-templates/type6_3_5_grade_term2.html';
 import type_5_6_7_Term2_template from './views/generated-templates/type5_6_7_grade_term2.html';
 import type_5_8_Term2_template from './views/generated-templates/type5_8_grade_term2.html';

 import type_7_1_2_Term2_template from './views/generated-templates/type7_1_2_grade_term2.html';
 import type3to5_alncbseterm2Template from './views/generated-templates/type3to5_alncbseterm2.html'
 import type6to7_alncbse_term2Template from './views/generated-templates/type6to7_alncbse_term2.html'
 import typetermcbse_8to10term2Template from './views/generated-templates/typetermcbse_8to10_term2.html';
 import pt_1_no_convTemplate from './views/generated-templates/pt_1_no_conv.html'
 import UpdateLogTemplate from "./views/updateLog.html"

 import type1to5_tcscbse_new from './views/generated-templates/type1to5_tcscbse_new.html';
 import type1to5_tcscbseterm2_new from './views/generated-templates/type1to5_tcscbseterm2_new.html'

// NEW26 Teacher Templates
import type_5_1_2_Term1_new26_template from './views/generated-templates/type5_1_2_grade_term1_new26.html';
import type_5_1_2_Term2_new26_template from './views/generated-templates/type5_1_2_grade_term2_new26.html';
import type_5_3_5_Term1_new26_template from './views/generated-templates/type5_3_5_grade_term1_new26.html';
import type_5_3_5_Term2_new26_template from './views/generated-templates/type5_3_5_grade_term2_new26.html';
import type_6_6_7_Term1_new26_template from './views/generated-templates/type6_6_7_grade_term1_new26.html';
import type_6_6_7_Term2_new26_template from './views/generated-templates/type6_6_7_grade_term2_new26.html';
import type_8_to_10_Termcbse_new26_template from './views/generated-templates/type8to10_termcbse_new26.html';
import type_8_to_10_Termcbseterm2_new26_template from './views/generated-templates/type8to10_termcbseterm2_new26.html';
import type_9_termcbse_new26_template from './views/generated-templates/type9_termcbse_new26.html';
import type_9_termcbseterm2_new26_template from './views/generated-templates/type9_termcbseterm2_new26.html';
import type_10_termcbse_new26_template from
	'./views/generated-templates/type10_termcbse_new26.html';
import type_10_termcbseterm2_new26_template from
	'./views/generated-templates/type10_termcbseterm2_new26.html';
import type_02_grade_11_science_new26_template from './views/generated-templates/type02grade_11_science_new26.html';
import type_02_grade_11_sciencet2_new26_template from './views/generated-templates/type02grade_11_sciencet2_new26.html';
import type_02_grade_12_science_new26_template from './views/generated-templates/type02grade_12_science_new26.html';
import type_02_grade_12_sciencet2_new_template from './views/generated-templates/type02grade_12_sciencet2_new.html';
import type_10_KB_grade_term1_new26_template from './views/generated-templates/type10_KB_grade_term1_new26.html';
import type_10_KB_grade_term2_new26_template from './views/generated-templates/type10_KB_grade_term2_new26.html';

const name = 'viewGeneratedReportData'

class reportGeneratedViewController {
    constructor($scope, $state, $window, $mdMedia, $mdDialog, $stateParams, authService,
        localStorageService, rcConstants, CONSTANTS, $sce, $rootScope, RC_CONSTANTS_) {
        'ngInject';
        let self = this
        $scope.showButton = false
        $scope.loading = true
        self.conditions = {}
        $scope.showButton = false
        $scope.showPending=false
        $scope.updateLogs = []
        $rootScope.title = "Generated Report";
        var activeYear = localStorageService.get('academic_year')
        const _KG_CLASSES = ["class123", "class1234"]
        const _FIVE_MARKS_ = 5
        if ($stateParams.selected_year != activeYear) {
            self.noAction = true
        } else {
            self.noAction = false
        }
        $scope.published_edit = $stateParams.is_edit
        let subsSettng = undefined,
            subsPrsn = undefined,
            subsRprt = undefined;
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, { reload: true })
            }
            pushLog();
        }
        this.$onDestroy = () => {
            if (subsSettng)
                subsSettng.stop()
            if (subsPrsn)
                subsPrsn.stop()
            if (subsRprt)
                subsRprt.stop()
        }

        let authoring = localStorageService.get('authoringData')
        var reportDataId = $stateParams.dataId
        this.sendForApprovalFlag = false
        this.can_published_edit = false
        this.can_published_edit = false
        function intializeFlags(){
            $scope.oneToFiveSkillOnlyFlag = false
            $scope.oneToFiveSkillAndSubSkillFlag = false
            $scope.SixToEightScholasticFlag = false
            $scope.locationUrl = CONSTANTS.FILE_UPLOAD_URL
            $scope.typeOneMark = false
            $scope.typeOneGrade = false
            $scope.typeTwoMark = false
            $scope.typeThreeSubSkill = false
            $scope.defaultPtHf = false
            $scope.defaultPtAnnual = false
            $scope.default_skill_only = false
            $scope.type_four_mark = false
            $scope.type_four_annual = false
            $scope.defaultPtHfTwo = false
            $scope.defaultPtAnnualTwo = false
            $scope.cbsehss = false
            $scope.term1halfyearly = false
            $scope.kbhfhss = false
            self.allStudentReportData = undefined;
            $scope.grade9annual = false;
            $scope.grade0neeightAnnual = false
            $scope.annualcbseHss = false
            $scope.kbhssannual = false
            $scope.ptHfKB = false
            $scope.hfExamOne = false
            $scope.type5_9_10_grade_term1 = false
            $scope.type5_9_10_grade_term2 = false
            $scope.typefive_6_8_term1 = false
            $scope.typefive_6_8_term2 = false
            $scope.typefive_1_5term1 = false
            $scope.typefive_1_5term2 = false
            $scope.typefive_6_7_term1 = false
            $scope.typeseven_1_2_term1 = false
            $scope.typesix_6_7_term1 = false
            $scope.typesix_3_5_term1 = false
            $scope.typealn_1_2_term1 = false
            $scope.typefive_8_term1 = false
            $scope.typefive_1_2_term1 = false
            $scope.typesix_1_2_term1 = false
            $scope.typefive_3_5_term1 = false
            $scope.typefive_KB_105term1 = false
            $scope.typefive_KB_105term2 = false
            $scope.type5_KB_8_9_grade_term1 = false
            $scope.type5_KB_8_9_grade_term2 = false
            $scope.type5_KB_8_9_grade_term3 = false

            $scope.type_6_model_exam_term1 = false
            $scope.type_6_model_exam_term1nineten = false
            $scope.type_6_model_exam_term2nineten = false
            $scope.type_6_model_exam_term2 = false
            $scope.type_6_model_annualexam_term = false

            $scope.type9_cbse_pt1 = false
            $scope.type9_term1_hf = false
            $scope.type9_term2_ae = false
            $scope.type9_grade12term2_ae = false
            $scope.type9_kb_unit_test1 = false
            $scope.type9_kbterm1_hf = false
            $scope.type9_kbterm2 = false
            $scope.type9_kbterm3 = false
            $scope.type_7calicut_annual = false

            $scope.skill_template = undefined
            $scope.ApprovalUser = undefined
            $scope.type12termOneEightcbse = false
            $scope.type12_ninetentermcbse = false
            $scope.elt_report =false
            $scope.type20_KB_10_grade_term1 = false
            $scope.type20termNineTencbse = false
            $scope.type20termOneEightcbse = false
            $scope.type20_KB_10_grade_term2 = false
            $scope.type20term2NineTencbse = false
            $scope.type20termTwoOneEightcbse = false
            $scope.typeeightToTenTermCbse=false
            $scope.typeTermCbseeightToTen = false
            $scope.typesixToSevenAlnCbse= false
            $scope.typesixToSevenTcsCbse= false
            $scope.typethreeToFiveTcsCbse= false
            $scope.typethreeToFiveAlnCbse= false
            $scope.typeOneToTwoTcsCbse= false



            $scope.typethirtykbtenTermOne = false
            $scope.typethirtykbtenTermTwo = false
            $scope.typethirtykbtenTermThree = false
            $scope.typethirtykbtenTermOneNew26 = false
            $scope.typethirtykbtenTermTwoNew26 = false
            $scope.typethirtykbtenTermThreeNew26 = false

			$scope.typetenkbtenTermOne = false
			$scope.typetenkbtenTermTwo = false
			$scope.typetenkbeleventwelveTermOne = false
			$scope.typetenkbeleventwelveTermTwo = false
			$scope.typetenkbeleventwelveTermOneNew26 = false
			$scope.typetenkbeleventwelveTermTwoNew26 = false
            $scope.type02grade11sc = false
            $scope.type02grade11sct2 = false
            $scope.type02grade12sc = false
            $scope.type02grade12sct2 = false
			$scope.typefivethreefiveterm2 = false
            $scope.typeonetwoshjterm2 = false
			$scope.typesix_6_7_term2 = false
			$scope.typeeightToTenTermCbseterm2=false
			$scope.typefive_1_2_term2 = false
			$scope.typeOneToTwoTcsCbseterm2=false
			$scope.typesixToSevenTcsCbseTerm2 = false
			$scope.typethreeToFiveTcsCbseTerm2 = false
			$scope.typesix_3_5_term2 = false
			$scope.typefive_6_7_term2 = false
			$scope.typefive_8_term2 = false
			$scope.typeseven_1_2_term2 = false
			$scope.typethreeToFiveAlnCbseterm2 = false
            $scope.type6to7_alncbse_term2 =false
			$scope.typeTermCbseeightToTenterm2 = false
            $scope.pt_1_no_conv = false
            $scope.type1to5_tcscbse_new = false
            $scope.type1to5_tcscbseterm2_new = false

			// NEW26 Templates
			$scope.type5_1_2_term1_new26 = false;
			$scope.type5_1_2_term2_new26 = false;
			$scope.type5_3_5_term1_new26 = false;
			$scope.type5_3_5_term2_new26 = false;
			$scope.type6_6_7_term1_new26 = false;
			$scope.type6_6_7_term2_new26 = false;
			$scope.type8to10_termcbse_new26 = false;
			$scope.type8to10_termcbseterm2_new26 = false;
				$scope.type9_termcbse_new26 = false;
				$scope.type9_termcbseterm2_new26 = false;
				$scope.type10_termcbse_new26 = false;
				$scope.type10_termcbseterm2_new26 = false;
				$scope.type02grade_11_science_new26 = false;
				$scope.type02grade_11_sciencet2_new26 = false;
				$scope.type02grade_12_science_new26 = false;
				$scope.type02grade_12_sciencet2_new = false;
				$scope.type10_kb_grade_term1_new26 = false;
				$scope.type10_kb_grade_term2_new26 = false;


        }
        intializeFlags()

        let school_id = localStorageService.get('school_id')
        function loadPage(result) {
            // NEW26 Debug: Log incoming data
            console.log('=== CLIENT NEW26 DEBUG: loadPage called ===');
            console.log('Result object keys:', Object.keys(result));
            console.log('result.rc_template:', result.rc_template);
            console.log('result.report_template:', result.report_template);
            if(result && result.rc_template){
                console.log('Template from server:', result.rc_template.template);
                console.log('Is NEW26 template:', result.rc_template.template.indexOf('new26') > -1 || result.rc_template.template.indexOf('NEW26') > -1);
            }
            console.log('=====================================');
            let lUser = localStorageService.get('user_id')
            console.log(result)
            if (reportDataId) {
                if (result && result.pdf_data) {
                    $scope.url = result.pdf_data
                } else {
                    $scope.url = CONSTANTS.FILE_UPLOAD_URL +
                        "/uploads/academic_reports/" + lUser + "/" + result.pdf_url
                }
                $scope.loading = false
                var cardDetails = []
                if (result) {
                    $scope.withOutSkillButMark = true
                    self.full_data = result
                    self.card_details = result.card_details
                        ? result.card_details
                        : result.report_template.activity_buckets
                    let report_data = result.report_data
                    if (report_data.current_status.status != "rejected" && $scope.published_edit == "true") {
                        self.can_published_edit = true
                    }
                    try {
                        let allowed_edit_years = ['2024-2025', '2025-2026', '2026-2027']
                        let selected_year = report_data.report_card_header.academic_year
                        console.log(selected_year, "selected_yearselected_year")
                        if (!allowed_edit_years.includes(selected_year) ||
                            (selected_year == activeYear && report_data.current_status.status == "approved")) {
                            self.can_published_edit = false
                        }
                    } catch (error) {
                        console.log(error);
                    }
                    $scope.report_data = report_data
                    let academicDetails = {
                        report_name: report_data.report_card_header.report_card_name,
                        school_name: "School Name Dummy",
                        generated_by: report_data.generated_by.name,
                        academics: report_data.academic_details.session +
                            "/" + report_data.academic_details.curriculum +
                            "/" + report_data.academic_details.class +
                            "/" + report_data.academic_details.batch,
                        subject: report_data.academic_details.subject
                    }
                    if(result.stream){
                        academicDetails.stream = result.stream
                    }
                    self.academic_header = academicDetails
                    report_data.results.sort(function (a, b) {
                        var nameA = a.student_name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.student_name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                    if (result.rc_template.template === rcConstants.TYPE_3_SUB_SLILL) {
                        $scope.skill_template = rcConstants.TYPE_3_SUB_SLILL
                        _.each(report_data.results, function (eachStudent) {
                            eachStudent['result_redefined'] = {}
                            _.each(eachStudent.skills, function (eachSkill) {
                                let sub_obj = {}
                                _.each(eachSkill.sub_skill, function (subSkill) {
                                    sub_obj[subSkill.subname] = {
                                        "name": subSkill.subname,
                                        "grade": subSkill.grade,
                                        "remarks": subSkill.remarks,
                                        "total_mark": subSkill.total_mark,
                                    }
                                })
                                eachStudent['result_redefined'][eachSkill.name] = {
                                    "name": eachSkill.name,
                                    "grade": eachSkill.grade,
                                    "total_mark": eachSkill.total_mark,
                                    "subSkill": sub_obj
                                }
                            })
                        })
                    } else {
                        if (result.rc_template.template === rcConstants.TYPE_SKILL_ONLY) {
                            $scope.skill_template = rcConstants.TYPE_SKILL_ONLY
                            _.each(report_data.results, function (eachStudent) {
                                eachStudent['result_redefined'] = {}
                                _.each(eachStudent.skills, function (skill) {
                                    eachStudent['result_redefined'][skill.name] = skill
                                })
                            })
                        }
                    }
                    if (result.rc_template) {
                        switchTemplate(result.rc_template.template)
                    }
                    self.allStudentReportData = report_data
                    if (result.sendForButtonShow == true) {
                        self.sendForApprovalFlag = true
                    }
                    _.defer(function () { $scope.$apply(); });
                }

            }
        }
        let loadObj = {
            reportDataId: reportDataId,
            school_id: school_id,
            pdfFlag: false,
            authoring: authoring,
            can_approve: false,
            year: $stateParams.selected_year,
            isGeneration: false,
            my_user_id: localStorageService.get('user_id'),
            CONSTANTS: CONSTANTS
        }
        function initialLoad(loadObj) {

            authService.callAPI("/v0/reportcards/teacher/subject/report", "POST",
                { args: loadObj }, function (response) {
                    // if(response.error){
                    //     $scope.loading = false
                    //     toastr.error(response.error)
                    //     return false
                    // }response.reportCardApprover
                    if (response && response.result && response.result.data && response.result.data.details && response.result.data.details.response) {
                        if(response.result.data.details.response.report_data && response.result.data.details.response.report_data.update_logs){
                            $scope.updateLogs = response.result.data.details.response.report_data.update_logs
                        }
                        if (response.result.data.details.response.permissions.reportCardListing ||
                            response.result.data.details.response.permissions.publishReports ||
                            response.result.data.details.response.permissions.reportCardApprover) {
                            self.can_approve = true
                        } else {
                            $state.go("dashboard")
                            return false
                        }
                        self.roles = response.result.data.details.response.approverRoles
                        let sdata = response.result.data.details.response.permissions.schoolData
                        sdata.logo = CONSTANTS.FILE_UPLOAD_URL + sdata.logo
                        $scope.schoolData = sdata
                        self.can_approve = true
                        let report_data = response.result.data.details.response.report_data
                        if (report_data.current_status && report_data.current_status.status === 'approved') {
                            $scope.showButton = false
                            $scope.loading = false
                        }

                        if (response.result.data.details.response.approve_permission) {
                            // $scope.showButton = true
                            if (report_data.current_status && report_data.current_status.status === 'sent_for_approval') {

                                if (report_data.approval_details && report_data.approval_details.length) {
                                    let isMeApprover = _.find(report_data.approval_details, function (one) {
                                        return one.user_id == localStorageService.get('user_id') &&
                                            one.status == "received"
                                    })
                                    if (isMeApprover) {
                                        $scope.showButton = true
                                    }
                                    if ( !isMeApprover) {
                                        $scope.ApprovalUser = report_data.approval_details[0].user_name;
                                        $scope.showPending = true
                                    }
                                }
                                $scope.loading = false
                            }
                            if (report_data.current_status && report_data.current_status.status === 'created' ||
                                report_data.current_status.status === 're_generated') {
                                self.sendForApprovalFlag = true
                            }
                        }
                        loadPage(response.result.data.details.response);
                    }
                    $scope.loading = false
                })
        }
        initialLoad(loadObj)

        function switchTemplate(template) {
            console.log("templates",template)
            console.log(rcConstants)
            switch (template) {
                case rcConstants.TYPE_1_MARK:
                    $scope.typeOneMark = true
                    break;
                case rcConstants.TYPE_1_GRADE:
                    $scope.typeOneGrade = true
                    break;
                case rcConstants.TYPE_2_MARK:
                    $scope.typeTwoMark = true
                    break;
                case rcConstants.TYPE_3_SUB_SLILL:
                    $scope.typeThreeSubSkill = true
                    break;
                case rcConstants.TYPE_1_DEFAULT_ANNUAL:
                    $scope.typeOneMark = true
                    break;
                case rcConstants.DEFAULT_PERIODICTEST_HF:
                    $scope.defaultPtHf = true
                    break;
                case rcConstants.DEFAULT_PERIODICTEST_ANNUAL:
                    $scope.defaultPtAnnual = true
                    break;
                case rcConstants.TYPE_SKILL_ONLY:
                    $scope.default_skill_only = true
                    break;
                case rcConstants.TYPE_4_MARK:
                    $scope.type_four_mark = true
                    break;
                case rcConstants.TYPE_4_ANNUAL:
                    $scope.type_four_annual = true
                    break;
                case rcConstants.DEFAULT_PERIODICTEST_HF_TWO:
                    $scope.defaultPtHfTwo = true
                    break;
                case rcConstants.DEFAULT_PERIODICTEST_ANNUAL_TWO:
                    $scope.defaultPtAnnualTwo = true
                    break;
                case rcConstants.HIGHER_SECONDARY_REPORT:
                    $scope.defaultHss = true
                    break;
                case rcConstants.CBSE_HSHF:
                    $scope.cbsehss = true
                    break;
                case 'term1halfyearly':
                    $scope.term1halfyearly = true
                    break;
                case rcConstants.KBHFHSS:
                    $scope.kbhfhss = true
                    break;
                case "grade-9-annual":
                    $scope.grade9annual = true
                    break;
                case "grade-1_8-annual":
                    $scope.grade0neeightAnnual = true
                    break;
                case "annual_cbse_hss":
                    $scope.annualcbseHss = true
                    break;
                case 'term-annual-only':
                    $scope.annualnineonly = true
                    break;
                case "kb_hss_annual":
                    $scope.kbhssannual = true
                    break;
                case "periodic-test-hf-kb":
                    $scope.ptHfKB = true
                case "hf1-exam":
                    $scope.hfExamOne = true
                    break;
                case "type5_9_10_grade_term1":
                    $scope.type5_9_10_grade_term1 = true
                    break;
                case "type5_6_8_grade_term1":
                    $scope.typefive_6_8_term1 = true
                    break;
                case "type5_6_8_grade_term2":
                    $scope.typefive_6_8_term2 = true
                    break;
                case "type5_1_5_grade_term1":
                    $scope.typefive_1_5term1 = true
                    break;
                case "type5_1_5_grade_term2":
                    $scope.typefive_1_5term2 = true
                    break;
				case "type5_6_7_grade_term1":
					$scope.typefive_6_7_term1 = true
					break;
				case "type6_6_7_grade_term1":
					$scope.typesix_6_7_term1 = true
					break;
				case "type6_3_5_grade_term1":
					$scope.typesix_3_5_term1 = true
					break;

				case "typealn_1_2_grade_term1":
					$scope.typealn_1_2_term1 = true
					break;
				case "type5_8_grade_term1":
					$scope.typefive_8_term1 = true
					break;
				case "type7_1_2_grade_term1":
					$scope.typeseven_1_2_term1 = true
					break;
				case "type5_1_2_grade_term1":
					$scope.typefive_1_2_term1 = true
					break;
				case "type6_1_2_grade_term1":
					$scope.typesix_1_2_term1 = true
					break;
				case "type5_3_5_grade_term1":
					$scope.typefive_3_5_term1 = true
					break;
                case "type5_KB_10_grade_term1":
                    $scope.typefive_KB_105term1 = true
                    break;
                case "type5_KB_10_grade_term2":
                    $scope.typefive_KB_105term2 = true
                    break;
                case "type5_9_10_grade_term2":
                    $scope.type5_9_10_grade_term2 = true
                    break;
                case "type5_KB_8_9_grade_term1":
                    $scope.type5_KB_8_9_grade_term1 = true
                    break;
                case "type5_KB_8_9_grade_term2":
                    $scope.type5_KB_8_9_grade_term2 = true
                    break;
                case "type5_KB_8_9_grade_term3":
                    $scope.type5_KB_8_9_grade_term3 = true
                    break;
                case "type_6_model_exam_1":
                    $scope.type_6_model_exam_term1 = true;
                    break;
                case "type_6_model_exam_1_nineten":
                    $scope.type_6_model_exam_term1nineten = true;
                    break;
                case 'type_6_model_exam_2_nineten':
                    $scope.type_6_model_exam_term2nineten = true
                    break;
                case "type_6_model_exam_2":
                    $scope.type_6_model_exam_term2 = true
                    break;
                case "type_6_model_annualexam_2":
                    $scope.type_6_model_annualexam_term = true
                    break;
                case "calicut_annual":
                    $scope.type_7calicut_annual = true
                    break;
                case "type9_cbse_pt1":
                    $scope.type9_cbse_pt1 = true
                    break;
                case "type9_term1_hf":
                    $scope.type9_term1_hf = true
                    break;
                case "type9_term2_ae":
                    $scope.type9_term2_ae = true
                    break;
                case "type9_grade12term2_ae":
                    $scope.type9_grade12term2_ae = true
                    break;
                case "type9_kb_unit_test1":
                    $scope.type9_kb_unit_test1 = true
                    break;
                case "type9_kbterm1_hf":
                    $scope.type9_kbterm1_hf = true
                    break;
                case "type9_kbterm2":
                    $scope.type9_kbterm2 = true
                    break;
                case "type9_kbterm3":
                    $scope.type9_kbterm3 = true
                    break;
                case  "type12_termcbse":
                    $scope.type12termOneEightcbse = true
                    break;
                case  "type12_ninetentermcbse":
                    $scope.type12_ninetentermcbse = true
                    break;
                case  "elt-report":
                    console.log('ooooooo')
                    $scope.elt_report = true
                    break;
                case  "type20_KB_10_grade_term1":
                    $scope.type20_KB_10_grade_term1 = true
                    break;
                case  "type20_termcbse":
                    $scope.type20termNineTencbse = true
                    break;
                case  "type20_termcbse18":
                    $scope.type20termOneEightcbse = true
                    break;
                case  "type20_term2cbse":
                    $scope.type20term2NineTencbse = true
                    break;
                case  "type20_term2cbse18":
                    $scope.type20termTwoOneEightcbse = true
                    break;
                case  "type20_KB_10_grade_term2":
                    $scope.type20_KB_10_grade_term2 = true
                    break;
                case "type30_KB_grade_term1":
                    $scope.typethirtykbtenTermOne = true
                    break;
                case "type30_KB_grade_term2":
                    $scope.typethirtykbtenTermTwo = true
                    break;
                case "type30_KB_grade_term3":
                    $scope.typethirtykbtenTermThree = true
                    break;
                case "type30_KB_grade_term1_new26":
                    $scope.typethirtykbtenTermOneNew26 = true
                    break;
                case "type30_KB_grade_term2_new26":
                    $scope.typethirtykbtenTermTwoNew26 = true
                    break;
                case "type30_KB_grade_term3_new26":
                    $scope.typethirtykbtenTermThreeNew26 = true
                    break;
                case  "type8to10_termcbse":
                    $scope.typeeightToTenTermCbse = true
                    break;
                case  "typetermcbse_8to10":
                    $scope.typeTermCbseeightToTen = true
                    break;
                case "type6to7_alncbse":
                    $scope.typesixToSevenAlnCbse = true
                    break;
                case "type6to7_tcscbse":
                    $scope.typesixToSevenTcsCbse = true
                    break
                case "type3to5_tcscbse":
                    $scope.typethreeToFiveTcsCbse = true
                    break;
                case "type3to5_alncbse":
                    $scope.typethreeToFiveAlnCbse = true
                    break;
                case "type1to2_tcscbse":
                    $scope.typeOneToTwoTcsCbse=true
                    break;
				case "type10_KB_grade_term1":
					$scope.typetenkbtenTermOne = true
					break;
				case "type10_KB_grade_term2":
					$scope.typetenkbtenTermTwo = true
					break;
				case "type10_KB_grade11_12_term1_new26":
					$scope.typetenkbeleventwelveTermOneNew26 = true
					break;
				case "type10_KB_grade11_12_term2_new26":
					$scope.typetenkbeleventwelveTermTwoNew26 = true
					break;
				case "type10_KB_grade11_12_term1":
					$scope.typetenkbeleventwelveTermOne  = true
					break;
				case "type10_KB_grade11_12_term2":
					$scope.typetenkbeleventwelveTermTwo = true
					break;
                case "type02grade_11_science":
                    $scope.type02grade11sc = true
                    break;
                case "type02grade_11_sciencet2":
                    $scope.type02grade11sct2 = true
                    break;
                case "type02grade_12_science":
                    $scope.type02grade12sc = true
                    break;
                case "type02grade_12_sciencet2":
                    $scope.type02grade12sct2 = true
                    break;
				case "type5_3_5_grade_term2":
					$scope.typefivethreefiveterm2 = true
					break;
				case "type6_6_7_grade_term2":
					$scope.typesix_6_7_term2 = true
					break;

				case  "type8to10_termcbseterm2":
					$scope.typeeightToTenTermCbseterm2 = true
					break;
				case "type5_1_2_grade_term2":
					$scope.typefive_1_2_term2 = true
					break;
                case "type1to2shjcbset2":
                    $scope.typeonetwoshjterm2 = true
                    break;
				case "type1to2_tcscbse_term2":
					$scope.typeOneToTwoTcsCbseterm2=true
					break;
				case "type6to7_tcscbseterm2":
					$scope.typesixToSevenTcsCbseTerm2 = true
					break
				case "type3to5_tcscbseterm2":
					$scope.typethreeToFiveTcsCbseTerm2 = true
					break;
				case "type6_3_5_grade_term2":
					$scope.typesix_3_5_term2 = true
					break;
				case "type5_6_7_grade_term2":
					$scope.typefive_6_7_term2 = true
					break;
				case "type5_8_grade_term2":
					$scope.typefive_8_term2 = true
					break;
				case "type7_1_2_grade_term2":
					$scope.typeseven_1_2_term2 = true
					break;
				case "type3to5_alncbseterm2":
					$scope.typethreeToFiveAlnCbseterm2 = true
					break;
                case "type6to7_alncbse_term2":
                    $scope.type6to7_alncbse_term2 = true
                    break;
				case  "typetermcbse_8to10_term2":
					$scope.typeTermCbseeightToTenterm2 = true
					break;
                case "pt_1_no_conv" :
                    $scope.pt_1_no_conv = true
                    break;
                case  "type1to5_tcscbse_new":
					$scope.type1to5_tcscbse_new = true
					break;
                case "type1to5_tcscbseterm2_new" :
                    $scope.type1to5_tcscbseterm2_new = true
                    break;
                }
			handleNew26Switch(template)
			console.log('=== NEW26 DEBUG: Switch case matched, template:', template);

        }

		function handleNew26Switch(template) {
			switch (template) {
			case "type5_1_2_grade_term1_new26":
			case "type5_1_2_grade_term1_new26_shj":
				$scope.type5_1_2_term1_new26 = true;
				break;
			case "type5_1_2_grade_term2_new26":
			case "type5_1_2_grade_term2_new26_shj":
				$scope.type5_1_2_term2_new26 = true;
				break;
			case "type5_3_5_grade_term1_new26":
				$scope.type5_3_5_term1_new26 = true;
				break;
			case "type5_3_5_grade_term2_new26":
				$scope.type5_3_5_term2_new26 = true;
				break;
			case "type6_6_7_grade_term1_new26":
				$scope.type6_6_7_term1_new26 = true;
				break;
			case "type6_6_7_grade_term2_new26":
				$scope.type6_6_7_term2_new26 = true;
				break;
			case "type8to10_termcbse_new26":
				$scope.type8to10_termcbse_new26 = true;
				break;
			case "type8_8_termcbseterm2_new26":
				$scope.type8to10_termcbseterm2_new26 = true;
				break;
			case "type8to10_termcbseterm2_new26":
				case "type9_termcbse_new26":
					$scope.type9_termcbse_new26 = true;
					break;
				case "type9_termcbseterm2_new26":
					$scope.type9_termcbseterm2_new26 = true;
					break;
				case "type10_termcbse_new26":
					$scope.type10_termcbse_new26 = true;
					break;
				case "type10_termcbseterm2_new26":
					$scope.type10_termcbseterm2_new26 = true;
					break;
				$scope.type8to10_termcbseterm2_new26 = true;
				break;
			case "type02grade_11_science_new26":
				$scope.type02grade_11_science_new26 = true;
				break;
				case "type02grade_11_sciencet2_new26":
					$scope.type02grade_11_sciencet2_new26 = true;
					break;
				case "type02grade_12_science_new26":
					$scope.type02grade_12_science_new26 = true;
					break;
				case "type02grade_12_sciencet2_new":
					$scope.type02grade_12_sciencet2_new = true;
					break;
				case "type10_KB_grade_term1_new26":
					$scope.type10_kb_grade_term1_new26 = true;
					break;
				case "type10_KB_grade_term2_new26":
					$scope.type10_kb_grade_term2_new26 = true;
					break;
			}
		}

        self.showModal = (ev) => {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'reportDataId', 'selected_year',
                    'school_id', 'localStorageService', 'authService', 'parentScope', MdController],
                locals: {
                    "reportDataId": reportDataId,
                    "selected_year": $stateParams.selected_year,
                    school_id: school_id,
                    localStorageService: localStorageService,
                    authService: authService,
                    parentScope: $scope
                },
                template: reportCardApprovalPopup,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }
        self.selectUserByRole = (role_id) => {

            if (role_id) {
                self.users = [];
                self.conditions.role_selected = role_id
                let loadObj = {
                    role_id: role_id,
                    schoolId: localStorageService.get('school_id')
                }
                authService.callAPI("/v0/reportcards/teacher/approvers", "POST",
                    { args: loadObj }, function (response) {
                        let result = response.result.data.details.response
                        if (result) {

                            self.users = result;
                        }
                        _.defer(function () { $scope.$apply(); });
                    })

            }
        }
        self.setUser = (user_id) => {
            self.conditions.user_selected = user_id
        }
        self.confirmMarkUpdate = (ev) => {
            let confirm = $mdDialog.confirm({
                targetEvent: ev,
                    onComplete: function afterShowAnimation() {
                        var $dialog = angular.element(document.querySelector('md-dialog'));
                        var $actionsSection = $dialog.find('md-dialog-actions');
                        var $cancelButton = $actionsSection.children()[0];
                        var $confirmButton = $actionsSection.children()[1];
                        angular.element($confirmButton).addClass('md-raised submitEx');
                        angular.element($cancelButton).addClass('md-raised');
                        var $title = angular.element(document.querySelector('md-title'));
                        angular.element($title).addClass('md-raised md-accent');

                    }
                })
                .title('Are you sure to update Marks?')
                .htmlContent("<div class='mdCustom' style='line-height: 3.9;padding:5px !important;'><div style='padding: 10px !important;text-align:center;'>Please verify that the marks entered are correct.</div></br><div>Note : Entering anything other than numeric characters will be classified as an absence.</div></div>")
                // .textContent('Please make sure marks are entered correctly. Note : Entering Alpha Numerical characters will be considered as ABSENT.')
                // .ariaLabel('Lucky day')
                // .targetEvent(ev)
                .ok('UPDATE')
                .cancel('CANCEL')

            $mdDialog.show(confirm).then(function () {
                self.saveRemarks()
            }, function () {
                return false
            });
        }

        self.showUpdateLog = (ev) =>{
            if($scope.updateLogs.length){
                $mdDialog.show({
                    controller: DialogController,
                    template: UpdateLogTemplate,
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        updateLogs: $scope.updateLogs 
                    }
                });
            }
            else{
                toastr.error("Update log not available")
            }

        }
        function DialogController($scope, $mdDialog, updateLogs) {

            try {
                $scope.updateLogs = angular.copy(updateLogs);
            } catch (error) {
                $scope.updateLogs = JSON.parse(JSON.stringify(updateLogs));
            }

            try {
                $scope.updateLogs.sort((a, b) => new Date(b.updated_on) - new Date(a.updated_on));
                for(let item of $scope.updateLogs){
                    if(item.updated_on){
                        item.updated_on = formatToMMDDYY(item.updated_on)
                    }
                }
            } catch (error) {
                console.log(error);
                
            }

            $scope.closeDialog = function() {
                $mdDialog.hide();
            };

            function formatToMMDDYY(isoString) {
                const date = new Date(isoString);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const year = String(date.getFullYear()).slice(-2);
                return `${day}-${month}-${year}`;
            }
        }
        function isNumber(n) {
            if(Math.round(n)==n && n.length==(Math.round(n)).length)
              return true;
            else return false;
        }
        self.saveRemarks = () => {

            if (!self.can_published_edit) {
                if (!self.conditions.role_selected || !self.conditions.user_selected) {
                    toastr.error("Please select the user")
                    return false
                }
            }

            let nullRemarks = false;
            let ifKgExceedFive = 0
            let error_exceeded = 0
            let errorStudents = []
            _.each(self.allStudentReportData.results, function (result) {
                delete result.empty
                delete result.invalid
                result.kgMarkExceederror = undefined
                if (result.result_redefined) {
                    let redefinedObj = result.result_redefined
                    let redefinedObjKeys = Object.keys(result.result_redefined)
                    _.each(redefinedObjKeys, function (redefObj) {
                        if (result.skills) {
                            _.each(result.skills, function (skill) {
                                if (skill.remarks == undefined) {
                                    nullRemarks = true;
                                }
                                if(authoring && authoring.class_id && self.can_published_edit){
                                    if(_KG_CLASSES.indexOf(authoring.class_id) !== -1){
                                        if(skill.total_mark > _FIVE_MARKS_){
                                            result.kgMarkExceederror = 'Marks exceeded ' + _FIVE_MARKS_
                                            ifKgExceedFive++
                                        }
                                    }
                                }
                                if (skill.name == redefObj) {
                                    if (redefinedObj[redefObj].subSkill) { //for subskills
                                        let subSkillObj = redefinedObj[redefObj].subSkill
                                        let subSkillObjKeys = Object.keys(redefinedObj[redefObj].subSkill)
                                        _.each(subSkillObjKeys, function (subKey) {
                                            _.each(skill.sub_skill, function (subSkill) {
                                                if (subSkill.subname == subKey) {
                                                    subSkill.remarks = subSkillObj[subKey].remarks
                                                    if (subSkill.remarks == undefined) {
                                                        nullRemarks = true;
                                                    }
                                                }
                                            })
                                        })
                                    }
                                }
                            })
                        }
                    })
                }else{
                    if(self.can_published_edit && $scope.report_data.no_conversion && $scope.report_data.bucket_max_mark){
                        let keys = Object.keys($scope.report_data.bucket_max_mark)
                        let ThisStudentError = 0
                        if(keys && keys.length){
                            for (let k = 0; k < keys.length; k++) {
                                let element = keys[k];
                                try{
                                    if($scope.report_data.bucket_max_mark[element]){
                                        if($scope.report_data.bucket_max_mark[element].max_mark){
                                            let max_mark = $scope.report_data.bucket_max_mark[element].max_mark
                                            if(result.marks && result.marks[element]){
                                                if(!isNaN(result.marks[element])){
                                                    if(Number(result.marks[element]) > Number(max_mark)){
                                                        console.log(result.marks[element] +'>' +max_mark)
                                                        ThisStudentError++
                                                        error_exceeded++
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }catch(e1){
                                    console.log(e1)
                                }
                            }
                        }
                        if(ThisStudentError){

                            errorStudents.push(result)
                        }
                    }
                }
            })
            if(error_exceeded && self.can_published_edit){
                if(errorStudents && errorStudents.length){
                    console.log(errorStudents)
                    showValidationFromServer({
                        error_array : errorStudents
                    })
                }
                return false
            }
            // return false
            if (self.allStudentReportData && self.allStudentReportData._id && self.allStudentReportData.results) {
                // Meteor.call("saveRemarksInTemplate", self.allStudentReportData, self.conditions, Session.get('school_id'), $stateParams.selected_year, function(error, result) {
                //     if (error) {
                //         toastr.error(error.reason)
                //     } else {
                //         if (result) {
                //             toastr.success("Successfully sent")
                //             $state.go('reportCardListing');
                //             // self.allStudentReportData = [];
                //             // self.allStudentReportData = result;
                //             // if (result.current_status && (result.current_status.status == "sent_for_approval")) {
                //             //     self.sendForApprovalFlag = false
                //             // }
                //         }
                //     }
                // })

                let loadObj = {
                    templateDataSet: self.allStudentReportData,
                    approverObj: self.conditions,
                    school_id: school_id,
                    report_academic_year: $stateParams.selected_year
                }

                let url = "/v0/reportcards/edit/published/subject/reportcard"
                let succes = "Sent for approval"
                if (!self.can_published_edit) {
                    url = "/v0/reportcards/teacher/saveRemarksInTemplate"
                    succes = "Sent for approval"
                }else{
                    loadObj['CONSTANTS'] = CONSTANTS
                    loadObj['my_user_id'] = localStorageService.get('user_id')
                    loadObj['rcConstants'] = rcConstants
                    loadObj['skill_template'] = $scope.skill_template
                    succes = "Mark Updated Successfully"
                    if(ifKgExceedFive){
                        toastr.error("Sorry..marks should not exceed 5")
                        return false
                    }

                }

                console.log(loadObj)
                $scope.loading = true
                authService.callAPI(url, "POST",
                    { args: loadObj }, function (response) {
                        if (!response.error) {
                            console.log(response)

                            self.sendForApprovalFlag = false
                            if (self.can_published_edit) {

                                let result = response.result.data.details.response
                                console.log(result)
                                if (result.validation_error > 0) {
                                    $scope.loading = false
                                    showValidationFromServer(result)
                                    return false
                                } else {

                                    toastr.success(succes)
                                    try{
                                        intializeFlags()
                                        let loadObj = {
                                            reportDataId: reportDataId,
                                            school_id: school_id,
                                            pdfFlag: false,
                                            authoring: authoring,
                                            can_approve: false,
                                            year: $stateParams.selected_year,
                                            isGeneration: false,
                                            my_user_id: localStorageService.get('user_id'),
                                            CONSTANTS: CONSTANTS
                                        }
                                        if(RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS && RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS.indexOf(school_id) !== -1){
                                            console.log("this")
                                            loadObj['PORT_FOLIO_AS_NB_SCHOOLS'] = true
                                        }
                                        initialLoad(loadObj)
                                    }catch(err){
                                        console.log(err)
                                        $scope.loading = false
                                        location.reload();
                                    }

                                }
                            }else{
                                $scope.loading = false
                            }
                            toastr.success(succes)
                        } else {
                            $scope.loading = false
                            toastr.success(error.error)
                        }

                        _.defer(function () { $scope.$apply(); });
                    })
            }
        }
        function showValidationFromServer(result) {
            try {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'validationData', validationCtrl],
                    locals: {
                        "validationData": result.error_array,

                    },
                    template: reportCardValidationPopup,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    // fullscreen: useFullScreen
                })
            } catch (e) {
                console.log(e)
            }
        }
        self.deleteReportCard = () => {
            $scope.loading = true
            let warn = "If you delete this data will be lost.And You have to create another one";
            if ($scope.report_data && $scope.report_data.current_status && $scope.report_data.current_status.status) {
                if ($scope.report_data.current_status.status == "re_generated") {
                    warn = "If you delete,only result of new student(s) will be deleted";
                }
            }
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete?')
                .textContent(warn)
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Dont delete');

            $mdDialog.show(confirm).then(function () {

                authService.callAPI("/v0/reportcards/teacher/delete", "POST",
                    { args: loadObj }, function (response) {
                        if (!response.error) {
                            let res = response.result.data.details.response
                            if (res.reverted) {
                                toastr.success('Deleted regenerated result of new student(s)')
                            } else {
                                toastr.success('deleted')
                            }
                            $state.go('reportCardListing')
                        } else {
                            toastr.success(error.error)
                        }
                    })
            }, function (f, r) {
                $scope.loading = false
            });

        }
        this.backToHtml = () => {
            $scope.pdfData = false
            $scope.downloadable = false
        }
        this.subjectTeacherExport = (data) => {
            // $scope.loading = true
            console.log(CONSTANTS.FILE_UPLOAD_URL)
            console.log($scope.url)
            $scope.pdfData = true
            $scope.urls = $sce.trustAsResourceUrl($scope.url)
            _.defer(function () { $scope.$apply(); });;
        }
        function pushLog(){
            let userId = localStorageService.get('user_id');
            let schoolId = localStorageService.get('school_id');
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+userId+"/"+schoolId+"/genaretedReportView", "GET", {},function (response) {
            // console.log(response)
			});
		}

}
}
class validationCtrl {
    constructor($scope, $mdDialog, validationData) {
        $scope.validationArray = validationData
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }


}
class MdController {
    constructor($scope, $mdDialog, reportDataId, selected_year, school_id,
        localStorageService, authService, parentScope) {
        $scope.dialogItem = [{
            _id: "123",
            "action": "Approve"
        }, {
            _id: "456",
            "action": "Reject"
        }]

        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.answer = function (answer) {
            $mdDialog.hide(answer);
        };
        $scope.saveAction = function () {
            let actionObj = {
                _id: reportDataId,
                actionItem: ($scope.item) ? $scope.item.action : null,
                commentItem: $scope.commentReason
            }
            let ret_val = []
            if (!actionObj) {
                toastr.error("Please select the action")
                return false
            }
            if (!actionObj.actionItem || !actionObj.commentItem) {
                if (!actionObj.actionItem) {
                    toastr.error("Please select the action")
                    return false
                }
                if (!actionObj.commentItem) {
                    toastr.error("Please enter the comment")
                    return false
                }
                if (!actionObj.actionItem && !actionObj.commentItem) {
                    toastr.error("Please select the action")
                    return false
                }
                return false
            }
            if (actionObj) {
                let loadObj = {
                    actionItem: actionObj,
                    commentItem: $scope.commentReason,
                    myUserId: localStorageService.get('user_id'),
                    selected_year: selected_year,
                    school_id: school_id,
                    _id: reportDataId
                }
                authService.callAPI("/v0/reportcards/teacher/decision", "POST",
                    { args: loadObj }, function (response) {
                        if (response.error) {
                            toastr.error('Please try after sometime')
                        } else {
                            let res = response.result.data.details.response
                            if (res) {
                                let msg = (actionObj.actionItem == 'Approve') ? "Approved" : "Rejected"
                                toastr.success(msg)
                                $mdDialog.cancel();
                            }
                        }
                        parentScope.showButton = false
                        _.defer(function () { $scope.$apply(); });
                    })
                // Meteor.call("statusAction", actionObj, selected_year, function(error, result) {
                //     if (error) {
                //         toastr.error(error.reason)

                //     } else {
                //         let msg = (actionObj.actionItem == 'Approve') ? "Approved" : "Rejected"
                //         toastr.success(msg)
                //         $mdDialog.cancel();
                //     }
                //     $scope.showButton = false
                //     _.defer(function() { $scope.$apply(); });;
                // })
            }
            // }
        }
    }
}
const typeFourMarkComponent = 'typeFourMarkComponent'
class TypeFourMarkComponent {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeFourMarkTemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeFourMarkTemplateCtrl.sendForApprovalFlag;
            vm.can_published_edit = this.typeFourMarkTemplateCtrl.can_published_edit;
        };

    }
}
const typeFourAnnualComponent = 'typeFourAnnualComponent'
class TypeFourAnnualComponent {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeFourAnnualTemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeFourAnnualTemplateCtrl.sendForApprovalFlag;
            vm.can_published_edit = this.typeFourAnnualTemplateCtrl.can_published_edit;
        };

    }
}
const typeOneMarkComponent = 'typeOneMarkComponent'
class TypeOneMarkClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeOneMarkTemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeOneMarkTemplateCtrl.sendForApprovalFlag;
            vm.can_published_edit = this.typeOneMarkTemplateCtrl.can_published_edit;
        };

    }
}
const typeTwoMarkComponent = 'typeTwoMarkComponent'
class TypeTwoMarkClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeTwoMarkTemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeTwoMarkTemplateCtrl.sendForApprovalFlag;
            vm.can_published_edit = this.typeTwoMarkTemplateCtrl.can_published_edit;
        };
    }
}
const typeThreeSubSkillComponent = 'typeThreeSubSkillComponent'
class TypeThreeSubSkillClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.typeThreeSubSkillCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeThreeSubSkillCtrl.sendForApprovalFlag;
            vm.card_details = this.typeThreeSubSkillCtrl.card_details;
            vm.can_published_edit = this.typeThreeSubSkillCtrl.can_published_edit;

        };
    }
}
const typeSkillOnlyComponent = 'typeSkillOnlyComponent'
class TypeSkillOnlyClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.typeSkillOnlyComponentCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeSkillOnlyComponentCtrl.sendForApprovalFlag;
            vm.card_details = this.typeSkillOnlyComponentCtrl.card_details;
            vm.can_published_edit = this.typeSkillOnlyComponentCtrl.can_published_edit;
        };
    }
}

const typeOneGradeComponent = 'typeOneGradeComponent'
class TypeOneGradeComponentClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.academic_header=undefined
        vm.card_details = undefined;
		vm.report_name = undefined;
        this.$onInit = function () {
            vm.academic_header=this.typeOneGradeComponentCtrl.academic_header
            vm.allStudentReportData = this.typeOneGradeComponentCtrl.allStudentReportData;
            if(vm.allStudentReportData .report_console_id == 'v93tfR4ScfZKkM297type02grade11Scdxb' ||
            vm.allStudentReportData .report_console_id == 'v93tfR4ScfZKkM297type02grade12Scdxb'){
                vm.allStudentReportData.report_card_header.report_card_name = 'TERM I'
            }else if(vm.allStudentReportData .report_console_id == 'v93tfR4ScfZKkM297type02grade11ScT2dxb' ||
            vm.allStudentReportData .report_console_id == 'v93tfR4ScfZKkM297type02grade12ScT2dxb'){
                vm.allStudentReportData.report_card_header.report_card_name = 'TERM II'
            }

            vm.sendForApprovalFlag = this.typeOneGradeComponentCtrl.sendForApprovalFlag;
            vm.card_details = this.typeOneGradeComponentCtrl.card_details;
            vm.can_published_edit = this.typeOneGradeComponentCtrl.can_published_edit;
			 vm.report_name = this.typeOneGradeComponentCtrl.full_data.rc_template.display_name;
			console.log(this.typeOneGradeComponentCtrl,"this.typeOneGradeComponentCtrl-----------------");
        };
    }
}
const periodicTestDeafaultHFcomponent = 'periodicTestDefaultHfComponent'
class PeriodicTestDeafaultHFClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.periodicTestDeafaultHFCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.periodicTestDeafaultHFCtrl.sendForApprovalFlag;
            vm.card_details = this.periodicTestDeafaultHFCtrl.card_details;
            vm.can_published_edit = this.periodicTestDeafaultHFCtrl.can_published_edit;
        };
    }
}
const periodicTestDeafaultAnnualcomponent = 'periodicTestDefaultAnnualComponent'
class PeriodicTestDeafaultAnnualClass {
    constructor($scope, $state, $window, $stateParams, $sce) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.periodicTestDeafaultAnnualCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.periodicTestDeafaultAnnualCtrl.sendForApprovalFlag;
            vm.card_details = this.periodicTestDeafaultAnnualCtrl.card_details;
            vm.can_published_edit = this.periodicTestDeafaultAnnualCtrl.can_published_edit;
        };
    }
}
const periodicTestDeafaultHFTwocomponent = 'periodicTestDefaultHfTwoComponent'
class PeriodicTestDefaultHfTwoClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.periodicTestDefaultHfTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.periodicTestDefaultHfTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.periodicTestDefaultHfTwoCtrl.card_details;
            vm.can_published_edit = this.periodicTestDefaultHfTwoCtrl.can_published_edit;
        };
    }
}
const periodicTestDefaultAnnualTwocomponent = 'periodicTestDefaultAnnualTwoComponent'
class PeriodicTestDefaultAnnualTwoClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.periodicTestDefaultAnnualTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.periodicTestDefaultAnnualTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.periodicTestDefaultAnnualTwoCtrl.card_details;
            vm.can_published_edit = this.periodicTestDefaultAnnualTwoCtrl.can_published_edit;
        };
    }
}
const hssTemplateComponent = 'hssTemplateComponent'
class HssTemplateComponentClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.hssTemplateComponentCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.hssTemplateComponentCtrl.sendForApprovalFlag;
            vm.card_details = this.hssTemplateComponentCtrl.card_details;
            vm.can_published_edit = this.hssTemplateComponentCtrl.can_published_edit;
        };
    }
}
const cbsehssComponent = 'cbsehssComponent'
class CbsehssClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.cbsehssComponentCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.cbsehssComponentCtrl.sendForApprovalFlag;
            vm.card_details = this.cbsehssComponentCtrl.card_details;
            vm.can_published_edit = this.cbsehssComponentCtrl.can_published_edit;
        };
    }
}
const termonehalfyearlyComp = 'termonehalfyearlyComp'
class TermonehalfyearlyCompClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.termonehalfyearlyCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.termonehalfyearlyCompCtrl.sendForApprovalFlag;
            vm.card_details = this.termonehalfyearlyCompCtrl.card_details;
            vm.can_published_edit = this.termonehalfyearlyCompCtrl.can_published_edit;
        };
    }
}
const kbhfhssComp = 'kbhfhssComp'
class KbhfhssCompClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.kbhfhssCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.kbhfhssCompCtrl.sendForApprovalFlag;
            vm.card_details = this.kbhfhssCompCtrl.card_details;
            vm.can_published_edit = this.kbhfhssCompCtrl.can_published_edit;
        };
    }
}
const gradeNineComp = 'gradeNineComp'
class gradeNineCompClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.gradeNineCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.gradeNineCompCtrl.sendForApprovalFlag;
            vm.card_details = this.gradeNineCompCtrl.card_details;
            vm.can_published_edit = this.gradeNineCompCtrl.can_published_edit;
        };
    }
}

const gradeOneEightComp = 'gradeOneEightComp'
class GradeOneEightCompClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.gradeOneEightCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.gradeOneEightCompCtrl.sendForApprovalFlag;
            vm.card_details = this.gradeOneEightCompCtrl.card_details;
            vm.can_published_edit = this.gradeOneEightCompCtrl.can_published_edit;
        };
    }
}
const annualCbseHssComp = 'annualCbseHssComp'
class AnnualCbseHssCompClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {

            vm.allStudentReportData = this.annualCbseHssCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.annualCbseHssCompCtrl.sendForApprovalFlag;
            vm.card_details = this.annualCbseHssCompCtrl.card_details;
            vm.can_published_edit = this.annualCbseHssCompCtrl.can_published_edit;
        };
    }
}
const annualNineOnlyComp = 'annualNineOnlyComp'
class AnnualNineOnlyClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.annualNineOnlyCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.annualNineOnlyCompCtrl.sendForApprovalFlag;
            vm.card_details = this.annualNineOnlyCompCtrl.card_details;
            vm.can_published_edit = this.annualNineOnlyCompCtrl.can_published_edit;
        };
    }
}
const kbannualComponent = 'kbannualComponent'
class KbannualComponentClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.kbannualComponentCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.kbannualComponentCtrl.sendForApprovalFlag;
            vm.card_details = this.kbannualComponentCtrl.card_details;
            vm.can_published_edit = this.kbannualComponentCtrl.can_published_edit;
        };
    }
}
const kbhfComponent = 'kbptHfComp'
class KbhfCompClass {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.kbhfPtCompCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.kbhfPtCompCtrl.sendForApprovalFlag;
            vm.card_details = this.kbhfPtCompCtrl.card_details;
            vm.can_published_edit = this.kbhfPtCompCtrl.can_published_edit;
        };
    }
}
const halfyearlyExam = 'halfyearlyExam'
class HalfyearlyExam {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.halfyearlyExamCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.halfyearlyExamCtrl.sendForApprovalFlag;
            vm.card_details = this.halfyearlyExamCtrl.card_details;
            vm.can_published_edit = this.halfyearlyExamCtrl.can_published_edit;
        };
    }
}
const typefiveNineTen = 'typefiveNineTen'
class TypefiveNineTen {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefiveNineTenCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefiveNineTenCtrl.sendForApprovalFlag;
            vm.card_details = this.typefiveNineTenCtrl.card_details;
            vm.can_published_edit = this.typefiveNineTenCtrl.can_published_edit;
        };
    }
}
const typefiveNineTenTermTwo = 'typefiveNineTenTermTwo'
class TypefiveNineTenTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefiveNineTenTermTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefiveNineTenTermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typefiveNineTenTermTwoCtrl.card_details;
            vm.can_published_edit = this.typefiveNineTenTermTwoCtrl.can_published_edit;
        };
    }
}
const typefiveSixEightTermone = 'typefiveSixEightTermone'
class TypefiveSixEightTerm1 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefiveSixEightTerm1Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefiveSixEightTerm1Ctrl.sendForApprovalFlag;
            vm.card_details = this.typefiveSixEightTerm1Ctrl.card_details;
            vm.can_published_edit = this.typefiveSixEightTerm1Ctrl.can_published_edit;

        };
    }
}

const typefiveSixEightTermtwo = 'typefiveSixEightTermtwo'
class TypefiveSixEightTerm2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefiveSixEightTerm2Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefiveSixEightTerm2Ctrl.sendForApprovalFlag;
            vm.card_details = this.typefiveSixEightTerm2Ctrl.card_details;
            vm.can_published_edit = this.typefiveSixEightTerm2Ctrl.can_published_edit;
        };
    }
}
const typefiveOneFiveTermone = 'typefiveOneFiveTermone'
class TypefiveOneFiveTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefiveOneFiveTermoneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefiveOneFiveTermoneCtrl.sendForApprovalFlag;
            vm.card_details = this.typefiveOneFiveTermoneCtrl.card_details;
            vm.can_published_edit = this.typefiveOneFiveTermoneCtrl.can_published_edit;

            console.log("🥰🥰🥰🥰🥰", vm.can_published_edit);
            
        };
    }
}
const typefiveOneFiveTermtwo = 'typefiveOneFiveTermtwo'
class TypefiveOneFiveTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefiveOneFiveTermtwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefiveOneFiveTermtwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typefiveOneFiveTermtwoCtrl.card_details;
        };
    }
}

const typefiveSixSevenTermone = 'typefiveSixSevenTermone'
class TypefiveSixSevenTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveSixSevenTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveSixSevenTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveSixSevenTermoneCtrl.card_details;
			vm.full_data = this.typefiveSixSevenTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typefiveSixSevenTermoneCtrl.can_published_edit;

        };
    }
}

const typesixSixSevenTermone = 'typesixSixSevenTermone'
class TypesixSixSevenTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesixSixSevenTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesixSixSevenTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typesixSixSevenTermoneCtrl.card_details;
			vm.full_data = this.typesixSixSevenTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typesixSixSevenTermoneCtrl.can_published_edit;

        };
    }
}

const typesevenOneTwoTermone = 'typesevenOneTwoTermone'
class TypesevenOneTwoTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesevenOneTwoTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesevenOneTwoTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typesevenOneTwoTermoneCtrl.card_details;
			vm.full_data = this.typesevenOneTwoTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typesevenOneTwoTermoneCtrl.can_published_edit;

        };
    }
}








const typealnOneTwoTermone = 'typealnOneTwoTermone'
class TypealnOneTwoTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typealnOneTwoTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typealnOneTwoTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typealnOneTwoTermoneCtrl.card_details;
			vm.full_data = this.typealnOneTwoTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typealnOneTwoTermoneCtrl.can_published_edit;

        };
    }
}
const  typefiveEightTermone = 'typefiveEightTermone'
class TypefiveEightTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveEightTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveEightTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveEightTermoneCtrl.card_details;
			vm.full_data = this.typefiveEightTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typefiveEightTermoneCtrl.can_published_edit;

        };
    }
}













// const typefiveOneTwoTermone = 'typefiveOneTwoTermone'
// class TypefiveOneTwoTermone {
//     constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
//         'ngInject';
//         let vm = this;
//         vm.allStudentReportData = undefined;
//         vm.card_details = undefined;
//         this.$onInit = function () {
//             vm.allStudentReportData = this.typefiveOneTwoTermoneCtrl.allStudentReportData;
//             vm.sendForApprovalFlag = this.typefiveOneTwoTermoneCtrl.sendForApprovalFlag;
//             vm.card_details = this.typefiveOneTwoTermoneCtrl.card_details;
// 			console.log("typefiveOneTwoTermoneCtrl",this.typefiveOneTwoTermoneCtrl)
//         };
//     }
// }



const  typesixOneTwoTermone = 'typesixOneTwoTermone'
class TypesixOneTwoTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesixOneTwoTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesixOneTwoTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typesixOneTwoTermoneCtrl.card_details;
			vm.full_data = this.typesixOneTwoTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.typesixOneTwoTermoneCtrl.can_published_edit;


        };
    }
}





const  typesixThreeFiveTermone = 'typesixThreeFiveTermone'
class TypesixThreeFiveTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesixThreeFiveTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesixThreeFiveTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typesixThreeFiveTermoneCtrl.card_details;
			vm.full_data = this.typesixThreeFiveTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typesixThreeFiveTermoneCtrl.can_published_edit;

        };
    }
}
// const typefiveOneTwoTermone = 'typefiveOneTwoTermone'
// class TypefiveOneTwoTermone {
//     constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
//         'ngInject';
//         let vm = this;
//         vm.allStudentReportData = undefined;
//         vm.card_details = undefined;
//         this.$onInit = function () {
//             vm.allStudentReportData = this.typefiveOneTwoTermoneCtrl.allStudentReportData;
//             vm.sendForApprovalFlag = this.typefiveOneTwoTermoneCtrl.sendForApprovalFlag;
//             vm.card_details = this.typefiveOneTwoTermoneCtrl.card_details;
// 			console.log("typefiveOneTwoTermoneCtrl",this.typefiveOneTwoTermoneCtrl)
//         };
//     }
// }





const  typefiveOneTwoTermone = 'typefiveOneTwoTermone'
class TypefiveOneTwoTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveOneTwoTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveOneTwoTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveOneTwoTermoneCtrl.card_details;
			vm.full_data = this.typefiveOneTwoTermoneCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.typefiveOneTwoTermoneCtrl.can_published_edit;

        };
    }
}



const  typefiveThreeFiveTermone = 'typefiveThreeFiveTermone'
class TypefiveThreeFiveTermone {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveThreeFiveTermoneCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveThreeFiveTermoneCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveThreeFiveTermoneCtrl.card_details;
			vm.full_data = this.typefiveThreeFiveTermoneCtrl.full_data;
			console.log("this.typefiveThreeFiveTermoneCtrl",this.typefiveThreeFiveTermoneCtrl)

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typefiveThreeFiveTermoneCtrl.can_published_edit;

        };
    }
}



const typefivekbtenTermOne = 'typefivekbtenTermOne'
class TypefivekbtenTermOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefivekbtenTermOneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefivekbtenTermOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typefivekbtenTermOneCtrl.card_details;
        };
    }
}





const typefivekbtenTermTwo = 'typefivekbtenTermTwo'
class TypefivekbtenTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefivekbtenTermTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefivekbtenTermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typefivekbtenTermTwoCtrl.card_details;
        };
    }
}
const typefivekbEightNineTermOne = 'typefivekbEightNineTermOne'
class TypefivekbEightNineTermOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefivekbEightNineTermOneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefivekbEightNineTermOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typefivekbEightNineTermOneCtrl.card_details;
        };
    }
}
const typefivekbEightNineTermTwo = 'typefivekbEightNineTermTwo'
class TypefivekbEightNineTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefivekbEightNineTermTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefivekbEightNineTermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typefivekbEightNineTermTwoCtrl.card_details;
        };
    }
}
const typefivekbEightNineTermThree = 'typefivekbEightNineTermThree'
class TypefivekbEightNineTermThree {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typefivekbEightNineTermThreeCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typefivekbEightNineTermThreeCtrl.sendForApprovalFlag;
            vm.card_details = this.typefivekbEightNineTermThreeCtrl.card_details;
        };
    }
}
const typesixModelExamTermOne = 'typesixModelExamTermOne'
class TypeSixModelExamOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            console.log('componentttttt')
            console.log(type_6_model_exam_1_template)
            vm.allStudentReportData = this.typeSixModelExamOneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeSixModelExamOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typeSixModelExamOneCtrl.card_details;
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typesixModelExamTermOnenineten = 'typesixModelExamTermOnenineten'
class TypesixModelExamTermOnenineten {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            console.log('componentttttt')
            console.log(type_6_model_exam_1nineten_template)
            vm.allStudentReportData = this.typesixModelExamTermOneninetenCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typesixModelExamTermOneninetenCtrl.sendForApprovalFlag;
            vm.card_details = this.typesixModelExamTermOneninetenCtrl.card_details;
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typesixModelExamTermTwonineten = 'typesixModelExamTermTwonineten'
class TypesixModelExamTermTwonineten {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            console.log('componentttttt')
            vm.allStudentReportData = this.typesixModelExamTermTwoninetenCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typesixModelExamTermTwoninetenCtrl.sendForApprovalFlag;
            vm.card_details = this.typesixModelExamTermTwoninetenCtrl.card_details;
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typesixModelExamTermTwoNospace = 'typesixModelExamTermTwoNospace'
class TypesixModelExamTermTwoNospace {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            console.log('componentttttt')
            vm.allStudentReportData = this.typesixModelExamTermTwoNospaceCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typesixModelExamTermTwoNospaceCtrl.sendForApprovalFlag;
            vm.card_details = this.typesixModelExamTermTwoNospaceCtrl.card_details;
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typesixModelAnnualExamTerm = 'typesixModelAnnualExamTerm'
class TypesixModelAnnualExamTerm {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            console.log('componentttttt')
            vm.allStudentReportData = this.typesixModelAnnualExamTermCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typesixModelAnnualExamTermCtrl.sendForApprovalFlag;
            vm.card_details = this.typesixModelAnnualExamTermCtrl.card_details;
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeSevenCalicultAnnual = 'typeSevenCalicultAnnual'
class TypeSevenCalicultAnnual {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeSevenCalicultAnnualCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeSevenCalicultAnnualCtrl.sendForApprovalFlag;
            vm.card_details = this.typeSevenCalicultAnnualCtrl.card_details;
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNinePT = 'typeNinePt'
class TypeNinePT {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNinePTCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNinePTCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNinePTCtrl.card_details;
            console.log(vm.allStudentReportData)
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            console.log(vm.card_details)
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNineTermOneHF = 'typeNineTermOneHf'
class TypeNineTermOneHF {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.can_published_edit = undefined
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNineTermOneHFCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNineTermOneHFCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNineTermOneHFCtrl.card_details;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            vm.can_published_edit = this.typeNineTermOneHFCtrl.can_published_edit;
        };
    }
}
const typeNineTermAe = 'typeNineTermAe'
class TypeNineTermAe {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNineTermAeCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNineTermAeCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNineTermAeCtrl.card_details;
            vm.full_data = this.typeNineTermAeCtrl.full_data;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subject && card.type9_specific_subjects &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.type9_specific_subject = true
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                        }
                    }
            }
            console.log(vm.card_details)
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNineTwelveTermAe = 'typeNineTwelveTermAe'
class TypeNineTwelveTermAe {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.type9_specific_subject = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNineTwelveTermAeCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNineTwelveTermAeCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNineTwelveTermAeCtrl.card_details;
            vm.full_data = this.typeNineTwelveTermAeCtrl.full_data;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subject && card.type9_specific_subjects &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.type9_specific_subject = true
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                        }
                    }
            }
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNinekbUnitTestOne = 'typeNinekbUnitTestOne'
class TypeNinekbUnitTestOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNinekbUnitTestOneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNinekbUnitTestOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNinekbUnitTestOneCtrl.card_details;
            console.log(vm.allStudentReportData)
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNineKbtermOnehf = 'typeNineKbtermOnehf'
class TypeNineKbtermOnehf {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNineKbtermOnehfCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNineKbtermOnehfCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNineKbtermOnehfCtrl.card_details;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNineKbtermTwo = 'typeNinekbtermTwo'
class TypeNineKbtermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNineKbtermTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNineKbtermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNineKbtermTwoCtrl.card_details;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const typeNinekbTermThreeCtrl = 'typeNinekbTermThree'
class TypeNinekbTermThreeCtrl {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.type9_specific_subject = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.typeNinekbTermThreeCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typeNinekbTermThreeCtrl.sendForApprovalFlag;
            vm.card_details = this.typeNinekbTermThreeCtrl.card_details;
            vm.full_data = this.typeNinekbTermThreeCtrl.full_data;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subject && card.type9_specific_subjects &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.type9_specific_subject = true
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                        }
                    }
            }
            // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
        };
    }
}
const type12termcbse = 'type12termcbse'
class Type12_termcbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type12_termcbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type12_termcbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type12_termcbseCtrl.card_details;
            vm.full_data = this.type12_termcbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type12_termcbseCtrl.can_published_edit;
        };
    }
}
const type12NineTentermcbse = 'type12NineTentermcbse'
class Type12NineTentermcbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.is_main = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type12NineTentermcbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type12NineTentermcbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type12NineTentermcbseCtrl.card_details;
            vm.full_data = this.type12NineTentermcbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) === -1 && card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) === -1){
                            vm.card_details = card.activity_buckets
                            vm.is_main = true
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type12NineTentermcbseCtrl.can_published_edit;
        };
    }
}

const eltPublishedReport = 'eltPublishedReport'
class EltPublishedReport {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.is_main = false
        this.$onInit = function () {
            vm.allStudentReportData = this.eltPublishedReportCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.eltPublishedReportCtrl.sendForApprovalFlag;
            vm.card_details = this.eltPublishedReportCtrl.card_details;
            vm.full_data = this.eltPublishedReportCtrl.full_data;

            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.eltPublishedReportCtrl.can_published_edit;
        };
    }
}
const type20kb10Gradeterm1 = 'type20kb10Gradeterm1'
class Type20kb10Gradeterm1Ctrl {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.is_main = false
        this.$onInit = function () {

            vm.allStudentReportData = this.type20kb10Gradeterm1Ctrl.allStudentReportData;
            let subject_id = vm.allStudentReportData.academic_details.subject_id
            vm.sendForApprovalFlag = this.type20kb10Gradeterm1Ctrl.sendForApprovalFlag;
            vm.card_details = this.type20kb10Gradeterm1Ctrl.card_details;
            vm.full_data = this.type20kb10Gradeterm1Ctrl.full_data;
            let card = vm.full_data.report_template
            vm.can_published_edit = this.type20kb10Gradeterm1Ctrl.can_published_edit;
            let _isMain = true, isSpecific = false, is40 = false
            if(card.subject_40_subjects && card.subject_40_subjects.subjects &&
                    card.subject_40_subjects.subjects.indexOf(subject_id) !== -1){
                _isMain = false
                isSpecific = false
                is40 = true
            }
            if(card.specific_subjects && card.specific_subjects.subjects &&
                 card.specific_subjects.subjects.indexOf(subject_id) !== -1){
                _isMain = false
                isSpecific = true
                is40 = false
            }
            vm._isMain = _isMain
            vm.isSpecific = isSpecific
            vm.is40 = is40
        };
    }
}

const type20termcbse = 'type20termcbse'
class Type20_termcbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type20_termcbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type20_termcbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type20_termcbseCtrl.card_details;
            vm.full_data = this.type20_termcbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.type20_termcbseCtrl.can_published_edit;
        };
    }
}

const type20termcbse18 = 'type20termcbse18'
class Type20_termcbse18 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type20_termcbse18Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type20_termcbse18Ctrl.sendForApprovalFlag;
            vm.card_details = this.type20_termcbse18Ctrl.card_details;
            vm.full_data = this.type20_termcbse18Ctrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type20_termcbse18Ctrl.can_published_edit;
        };
    }
}
const type20term2cbse = 'type20term2cbse'
class Type20_term2cbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.can_published_edit = undefined
        this.$onInit = function () {
            vm.allStudentReportData = this.type20_term2cbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type20_term2cbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type20_term2cbseCtrl.card_details;
            vm.full_data = this.type20_term2cbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.type20_term2cbseCtrl.can_published_edit;
        };
    }
}
const type20term2cbse18 = 'type20term2cbse18'
class Type20_termtwocbse18 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type20_term2cbse18Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type20_term2cbse18Ctrl.sendForApprovalFlag;
            vm.card_details = this.type20_term2cbse18Ctrl.card_details;
            vm.full_data = this.type20_term2cbse18Ctrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type20_term2cbse18Ctrl.can_published_edit;
        };
    }
}
const type20kb10Gradeterm2 = 'type20kb10Gradeterm2'
class Type20kb10Gradeterm2Ctrl {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.is_main = false
        this.$onInit = function () {

            vm.allStudentReportData = this.type20kb10Gradeterm2Ctrl.allStudentReportData;
            let subject_id = vm.allStudentReportData.academic_details.subject_id
            vm.sendForApprovalFlag = this.type20kb10Gradeterm2Ctrl.sendForApprovalFlag;
            vm.card_details = this.type20kb10Gradeterm2Ctrl.card_details;
            vm.full_data = this.type20kb10Gradeterm2Ctrl.full_data;
            let card = vm.full_data.report_template
            vm.can_published_edit = this.type20kb10Gradeterm2Ctrl.can_published_edit;
            let _isMain = true, isSpecific = false, is40 = false
            if(card.subject_40_subjects && card.subject_40_subjects.subjects &&
                    card.subject_40_subjects.subjects.indexOf(subject_id) !== -1){
                _isMain = false
                isSpecific = false
                is40 = true
            }
            if(card.specific_subjects && card.specific_subjects.subjects &&
                 card.specific_subjects.subjects.indexOf(subject_id) !== -1){
                _isMain = false
                isSpecific = true
                is40 = false
            }
            vm._isMain = _isMain
            vm.isSpecific = isSpecific
            vm.is40 = is40
        };
    }
}

const typethirtykbtenTermOne = 'typethirtykbtenTermOne'
class TypethirtykbtenTermOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia,localStorageService) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        let schoolid = localStorageService.get('school_id')
        let SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH']
        this.$onInit = function () {
            vm.full_data = this.typethirtykbtenTermOneCtrl.full_data;
            vm.allStudentReportData = this.typethirtykbtenTermOneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typethirtykbtenTermOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typethirtykbtenTermOneCtrl.card_details;
            vm.can_published_edit = this.typethirtykbtenTermOneCtrl.can_published_edit;
            let card = vm.full_data.report_template
            if (card.specific_subjects && card.specific_subjects &&
                card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                vm.moe_maxmark = 50
                if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                    vm.moe_maxmark = 100
                }
            }

        };
    }
}
const typethirtykbtenTermTwo = 'typethirtykbtenTermTwo'
class TypethirtykbtenTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia,localStorageService) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        let schoolid = localStorageService.get('school_id')
        let SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH']
        this.$onInit = function () {
            vm.full_data = this.typethirtykbtenTermTwoCtrl.full_data;
            vm.allStudentReportData = this.typethirtykbtenTermTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typethirtykbtenTermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typethirtykbtenTermTwoCtrl.card_details;
            vm.can_published_edit = this.typethirtykbtenTermTwoCtrl.can_published_edit;

            let card = vm.full_data.report_template
            if (card.specific_subjects && card.specific_subjects &&
                card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                vm.moe_maxmark = 50
                if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                    vm.moe_maxmark = 100
                }
            }
        };
    }
}


const type8to10termcbse = 'type8to10termcbse'
class Type8to10_termOnecbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type8to10_termcbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type8to10_termcbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type8to10_termcbseCtrl.card_details;
            vm.full_data = this.type8to10_termcbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type8to10_termcbseCtrl.can_published_edit;
        };
    }
}

const typetermcbse8to10 = 'typetermcbse8to10'
class TypetermOnecbse_8to10 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.typetermcbse_8to10Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typetermcbse_8to10Ctrl.sendForApprovalFlag;
            vm.card_details = this.typetermcbse_8to10Ctrl.card_details;
            vm.full_data = this.typetermcbse_8to10Ctrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.typetermcbse_8to10Ctrl.can_published_edit;
        };
    }
}

const type6to7alncbse = 'type6to7alncbse'
class Type6to7_termAlncbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type6to7_alncbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type6to7_alncbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type6to7_alncbseCtrl.card_details;
            vm.full_data = this.type6to7_alncbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type6to7_alncbseCtrl.can_published_edit;
        };
    }
}

const type6to7tcscbse = 'type6to7tcscbse'
class Type6to7_termTcscbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type6to7_tcscbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type6to7_tcscbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type6to7_tcscbseCtrl.card_details;
            vm.full_data = this.type6to7_tcscbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type6to7_tcscbseCtrl.can_published_edit;
        };
    }
}

const type3to5tcscbse = 'type3to5tcscbse'
class Type3to5_termTcscbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type3to5_tcscbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type3to5_tcscbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type3to5_tcscbseCtrl.card_details;
            vm.full_data = this.type3to5_tcscbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type3to5_tcscbseCtrl.can_published_edit;
        };
    }
}


const type3to5alncbse = 'type3to5alncbse'
 class Type3to5_termAlncbse {

    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type3to5_alncbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type3to5_alncbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type3to5_alncbseCtrl.card_details;
            vm.full_data = this.type3to5_alncbseCtrl.full_data;
            // let is25 = false
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            // is25 = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type3to5_alncbseCtrl.can_published_edit;
            // vm.is25 = is25
        };
    }
}

const type1to2tcscbse = 'type1to2tcscbse'
class Type1to2_termTcscbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type1to2_tcscbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type1to2_tcscbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type1to2_tcscbseCtrl.card_details;
            vm.full_data = this.type1to2_tcscbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type1to2_tcscbseCtrl.can_published_edit;
        };
    }
}

const typethirtykbtenTermThree = 'typethirtykbtenTermThree'
class TypethirtykbtenTermThree {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.subject_40_subjects = false
        vm.content_mngr = {
            is_specific : false,
            subject_40_subjects : false,
            subject_80_subjects : true
        }
        this.$onInit = function () {
            vm.full_data = this.typethirtykbtenTermThreeCtrl.full_data;
            vm.allStudentReportData = this.typethirtykbtenTermThreeCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typethirtykbtenTermThreeCtrl.sendForApprovalFlag;
            vm.card_details = this.typethirtykbtenTermThreeCtrl.card_details;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                //40
                console.log(card)
                if(card.subject_40_subjects && card.subject_40_subjects &&
                    card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length){
                        if(card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : false,
                                subject_40_subjects : true,
                                subject_80_subjects : false
                            }
                        }
                }
                //subjects on top
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        console.log(card.specific_subjects.subjects,'specific_subjectsspecific_subjects', vm.allStudentReportData.academic_details.subject_id)
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : true,
                                subject_40_subjects : false,
                                subject_80_subjects : false
                            }
                        }
                }
            }
        };
        console.log(vm.content_mngr)
    }
}


const typethirtykbtenTermOneNew26 = 'typethirtykbtenTermOneNew26'
class TypethirtykbtenTermOneNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this
        vm.full_data = undefined
        this.$onInit = function () {
            vm.full_data = this.typethirtykbtenTermOneNew26Ctrl.full_data;
            vm.allStudentReportData = this.typethirtykbtenTermOneNew26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag;
            vm.card_details = this.typethirtykbtenTermOneNew26Ctrl.card_details;
        };
    }
}

const typethirtykbtenTermTwoNew26 = 'typethirtykbtenTermTwoNew26'
class TypethirtykbtenTermTwoNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this
        vm.full_data = undefined
        this.$onInit = function () {
            vm.full_data = this.typethirtykbtenTermTwoNew26Ctrl.full_data;
            vm.allStudentReportData = this.typethirtykbtenTermTwoNew26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag;
            vm.card_details = this.typethirtykbtenTermTwoNew26Ctrl.card_details;
        };
    }
}

const typethirtykbtenTermThreeNew26 = 'typethirtykbtenTermThreeNew26'
class TypethirtykbtenTermThreeNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.subject_40_subjects = false
        vm.content_mngr = {
            is_specific : false,
            subject_40_subjects : false,
            subject_80_subjects : true
        }
        this.$onInit = function () {
            vm.full_data = this.typethirtykbtenTermThreeNew26Ctrl.full_data;
            vm.allStudentReportData = this.typethirtykbtenTermThreeNew26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag;
            vm.card_details = this.typethirtykbtenTermThreeNew26Ctrl.card_details;
            vm.can_published_edit = this.typethirtykbtenTermThreeNew26Ctrl.can_published_edit;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.subject_40_subjects && card.subject_40_subjects.subjects &&
                    card.subject_40_subjects.subjects.length){
                        if(card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : false,
                                subject_40_subjects : true,
                                subject_80_subjects : false
                            }
                        }
                }
                if(card.specific_subjects && card.specific_subjects.subjects &&
                    card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : true,
                                subject_40_subjects : false,
                                subject_80_subjects : false
                            }
                        }
                }
            }
        };
        console.log(vm.content_mngr)
    }
}



const typetenkbtenTermOne = 'typetenkbtenTermOne'
class TypetenkbTermOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
		'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.subject_40_subjects = false
        vm.content_mngr = {
            is_specific : false,
            subject_40_subjects : false,
            subject_80_subjects : true
        }
        let schoolid = localStorageService.get('school_id')
        let SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH']
        this.$onInit = function () {
            vm.full_data = this.typetenkbtenTermOneCtrl.full_data;
			// console.log(vm.full_data,"lllllllllllllllyyyyyyyyyyyyyyyyy")
            vm.allStudentReportData = this.typetenkbtenTermOneCtrl.allStudentReportData;
			// console.log(vm.allStudentReportData,"lllllllllllllllyyyyyyyyyyyyyyyyy")
            vm.sendForApprovalFlag = this.typetenkbtenTermOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typetenkbtenTermOneCtrl.card_details;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                //40
                console.log(card)
                if(card.subject_40_subjects && card.subject_40_subjects &&
                    card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length){
                        if(card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : false,
                                subject_40_subjects : true,
                                subject_80_subjects : false
                            }
                        }
                }
                //subjects on top
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        console.log(card.specific_subjects.subjects,'specific_subjectsspecific_subjects', vm.allStudentReportData.academic_details.subject_id)
						console.log(vm.typetenkbtenTermOneCtrl.can_published_edit,"lllllyyyy");
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : true,
                                subject_40_subjects : false,
                                subject_80_subjects : false
                            }
                            vm.moe_maxmark = 50
                            if(SCHOOLS_100.indexOf(schoolid) !== -1){
                                vm.moe_maxmark = 100
                            }
                        }
                }
            }
            vm.can_published_edit = this.typetenkbtenTermOneCtrl.can_published_edit;
        };
        console.log(vm.content_mngr)
    }
}

const typetenkbtenTermTwo = 'typetenkbtenTermTwo'
class TypetenkbTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia,localStorageService) {
		'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.subject_40_subjects = false
        vm.content_mngr = {
            is_specific : false,
            subject_40_subjects : false,
            subject_80_subjects : true
        }
        let schoolid = localStorageService.get('school_id')
        let SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH']
        this.$onInit = function () {
            vm.full_data = this.typetenkbtenTermTwoCtrl.full_data;
			// console.log(vm.full_data,"lllllllllllllllyyyyyyyyyyyyyyyyy")
            vm.allStudentReportData = this.typetenkbtenTermTwoCtrl.allStudentReportData;
			// console.log(vm.allStudentReportData,"lllllllllllllllyyyyyyyyyyyyyyyyy")
            vm.sendForApprovalFlag = this.typetenkbtenTermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typetenkbtenTermTwoCtrl.card_details;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                //40
                console.log(card)
                if(card.subject_40_subjects && card.subject_40_subjects &&
                    card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length){
                        if(card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : false,
                                subject_40_subjects : true,
                                subject_80_subjects : false
                            }
                        }
                }
                //subjects on top
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        console.log(card.specific_subjects.subjects,'specific_subjectsspecific_subjects', vm.allStudentReportData.academic_details.subject_id)
						console.log(vm.typetenkbtenTermTwoCtrl.can_published_edit,"lllllyyyy");
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific : true,
                                subject_40_subjects : false,
                                subject_80_subjects : false
                            }
                            vm.moe_maxmark = 50
                            if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                                vm.moe_maxmark = 100
                            }
                        }
                }
            }
        };
        // console.log(vm)
    }
}

const typetenkbeleventwelveTermOne = 'typetenkbeleventwelveTermOne'
class TypetenkbeleventwelveTermOne {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
		vm.is_specific = false
        let schoolid = localStorageService.get('school_id')
        let SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH']
        this.$onInit = function () {
			console.log( vm.full_data,"vm.full_data-------------");
            vm.full_data = this.typetenkbeleventwelveTermOneCtrl.full_data;
            vm.allStudentReportData = this.typetenkbeleventwelveTermOneCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typetenkbeleventwelveTermOneCtrl.sendForApprovalFlag;
            vm.card_details = this.typetenkbeleventwelveTermOneCtrl.card_details;
			if(vm.full_data && vm.full_data.report_template){

				let card = vm.full_data.report_template
				// console.log()
				console.log(vm.card_details,"77777777777777777")
				if(card.type10_specific_subjects && card.type10_specific_subjects &&
					card.type10_specific_subjects.subjects && card.type10_specific_subjects.subjects.length){
						if(card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
							vm.card_details = card.type10_specific_subjects.activity_buckets
							vm.is_specific = true
							// vm.additional_subjects = false
                            vm.moe_maxmark = 50
                            if(SCHOOLS_100.indexOf(schoolid) !== -1){
                                vm.moe_maxmark = 100
                            }
						}
					}
			}
// console.log(vm.full_data,"vm.full_data----");
        vm.can_published_edit = this.typetenkbeleventwelveTermOneCtrl.can_published_edit;
        };
    }
}


const typetenkbeleventwelveTermTwo = 'typetenkbeleventwelveTermTwo'
class TypetenkbeleventwelveTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
		vm.is_specific = false
        let schoolid = localStorageService.get('school_id')
        let SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH']
        this.$onInit = function () {
            vm.full_data = this.typetenkbeleventwelveTermTwoCtrl.full_data;
            vm.allStudentReportData = this.typetenkbeleventwelveTermTwoCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typetenkbeleventwelveTermTwoCtrl.sendForApprovalFlag;
            vm.card_details = this.typetenkbeleventwelveTermTwoCtrl.card_details;
			if(vm.full_data && vm.full_data.report_template){

				let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
				if(card.type10_specific_subjects && card.type10_specific_subjects &&
					card.type10_specific_subjects.subjects && card.type10_specific_subjects.subjects.length){
						if(card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
							vm.card_details = card.type10_specific_subjects.activity_buckets
							vm.is_specific = true
							// vm.additional_subjects = false

                            vm.moe_maxmark = 50
                            if(SCHOOLS_100.indexOf(schoolid) !== -1){
                                vm.moe_maxmark = 100
                            }
						}
					}
			}
            vm.can_published_edit = this.typetenkbeleventwelveTermTwoCtrl.can_published_edit;
// console.log(vm.full_data,"vm.full_data----");
        };
    }
}


const typetenkbeleventwelveTermOneNew26 = 'typetenkbeleventwelveTermOneNew26'
class TypetenkbeleventwelveTermOneNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        this.$onInit = function () {
            vm.full_data = this.typetenkbeleventwelveTermOneNew26Ctrl.full_data;
            vm.allStudentReportData = this.typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typetenkbeleventwelveTermOneNew26Ctrl.sendForApprovalFlag;
            vm.card_details = this.typetenkbeleventwelveTermOneNew26Ctrl.card_details;
            vm.can_published_edit = this.typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit;
            if (vm.full_data && vm.full_data.report_template) {
                let card = vm.full_data.report_template
                if (card.type10_specific_subjects && card.type10_specific_subjects.subjects &&
                    card.type10_specific_subjects.subjects.length) {
                    if (card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                        vm.card_details = card.type10_specific_subjects.activity_buckets
                        vm.is_specific = true
                    }
                }
            }
        };
    }
}

const typetenkbeleventwelveTermTwoNew26 = 'typetenkbeleventwelveTermTwoNew26'
class TypetenkbeleventwelveTermTwoNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        this.$onInit = function () {
            vm.full_data = this.typetenkbeleventwelveTermTwoNew26Ctrl.full_data;
            vm.allStudentReportData = this.typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typetenkbeleventwelveTermTwoNew26Ctrl.sendForApprovalFlag;
            vm.card_details = this.typetenkbeleventwelveTermTwoNew26Ctrl.card_details;
            vm.can_published_edit = this.typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit;
            if (vm.full_data && vm.full_data.report_template) {
                let card = vm.full_data.report_template
                if (card.type10_specific_subjects && card.type10_specific_subjects.subjects &&
                    card.type10_specific_subjects.subjects.length) {
                    if (card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                        vm.card_details = card.type10_specific_subjects.activity_buckets
                        vm.is_specific = true
                    }
                }
            }
        };
    }
}

const type02grade11sc = 'type02grade11sc'
class Type02grade11sc {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.academic_header= undefined
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.show_pct = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade11scCtrl.allStudentReportData;
            vm.academic_header=this.type02grade11scCtrl.academic_header
            vm.sendForApprovalFlag = this.type02grade11scCtrl.sendForApprovalFlag;
            vm.card_details = this.type02grade11scCtrl.card_details;
            $scope.getColspan = function(cardDetails) {
                return cardDetails.filter(function(bucket) {
                  return bucket.max_mark;
                }).length + 1;
              };
            if(vm.allStudentReportData.results[0] && vm.allStudentReportData.results[0]["marks"]){
                if(Object.keys(vm.allStudentReportData.results[0]["marks"]).includes("periodic_test")){
                    vm.show_pct = true
                }
            }
            vm.full_data = this.type02grade11scCtrl.full_data;
            vm.non_practical_sub = this.type02grade11scCtrl.full_data.report_template.type02_non_practical_sub

            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                // console.log(card,'vm.is_specific');
                if(card.type9_specific_subject &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type02grade11scCtrl.can_published_edit;

            vm.show_pct = vm.allStudentReportData.results.some(r =>
                r.marks && r.marks.pct !== undefined
            );

            let school_id = localStorageService.get('school_id')
            let school_list = []
            // vm.show_pct = true
            // if(!school_list.includes(school_id)){
            //     vm.show_pct = false
            // }
        };
    }
}

const type02grade11sct2 = 'type02grade11sct2'
class Type02grade11sct2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.academic_header= undefined
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade11sct2Ctrl.allStudentReportData;
            vm.academic_header=this.type02grade11sct2Ctrl.academic_header
            vm.sendForApprovalFlag = this.type02grade11sct2Ctrl.sendForApprovalFlag;
            vm.card_details = this.type02grade11sct2Ctrl.card_details;
            $scope.getColspan = function(cardDetails) {
                return cardDetails.filter(function(bucket) {
                  return bucket.max_mark;
                }).length + 1;
              };

            vm.full_data = this.type02grade11sct2Ctrl.full_data;
            vm.non_practical_sub = this.type02grade11sct2Ctrl.full_data.report_template.type02_non_practical_sub

            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                // console.log(card,'vm.is_specific');
                if(card.type9_specific_subject &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }

            let NO_MODEL_EXAM_SCHOOLS = ["CPpbKPQTcuG97i3kv", "m2LMtqaESFZf6xDE8"];
            let NO_MODEL_EXAM_YEARS = ["2025-2026", "2026-2027"];

            vm.hideModelExam =
                NO_MODEL_EXAM_SCHOOLS.indexOf(vm.full_data.school_id) !== -1 &&
                vm.full_data.permissions &&
                NO_MODEL_EXAM_YEARS.indexOf(vm.full_data.permissions.year) !== -1;

            if (vm.hideModelExam && vm.card_details) {
                vm.card_details = vm.card_details.filter(b => b.db_key !== 'model');
            }

            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type02grade11sct2Ctrl.can_published_edit;
        };
    }
}

const type02grade12sc = 'type02grade12sc'
class Type02grade12sc {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.academic_header=undefined
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.show_pct = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade12scCtrl.allStudentReportData;
            vm.academic_header=this.type02grade12scCtrl.academic_header
            vm.sendForApprovalFlag = this.type02grade12scCtrl.sendForApprovalFlag;
            vm.card_details = this.type02grade12scCtrl.card_details;
            $scope.getColspan = function(cardDetails) {
                return cardDetails.filter(function(bucket) {
                  return bucket.max_mark;
                }).length + 1;
              };

            vm.full_data = this.type02grade12scCtrl.full_data;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subject &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.allStudentReportData.results[0] && vm.allStudentReportData.results[0]["marks"]){
                if(Object.keys(vm.allStudentReportData.results[0]["marks"]).includes("pct")){
                    vm.show_pct = true
                }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type02grade12scCtrl.can_published_edit;
        };
    }
}

const type02grade12sct2 = 'type02grade12sct2'
class Type02grade12sct2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.academic_header=undefined
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade12sct2Ctrl.allStudentReportData;
            vm.academic_header=this.type02grade12sct2Ctrl.academic_header
            vm.sendForApprovalFlag = this.type02grade12sct2Ctrl.sendForApprovalFlag;
            vm.card_details = this.type02grade12sct2Ctrl.card_details;
            $scope.getColspan = function(cardDetails) {
                return cardDetails.filter(function(bucket) {
                  return bucket.max_mark;
                }).length + 1;
              };

            vm.full_data = this.type02grade12sct2Ctrl.full_data;
            vm.non_practical_sub = this.type02grade12sct2Ctrl.full_data.report_template.type02_non_practical_sub

            // console.log(this.type02grade12scCtrl,'fulllll');

            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subject &&
                    card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length){
                        if(card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.type9_specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type02grade12sct2Ctrl.can_published_edit;
        };
    }
}



const  typefiveThreeFiveTermtwo = 'typefiveThreeFiveTermtwo'
class TypefiveThreeFiveTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveThreeFiveTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveThreeFiveTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveThreeFiveTermtwoCtrl.card_details;
			vm.full_data = this.typefiveThreeFiveTermtwoCtrl.full_data;
			console.log("this.typefiveThreeFiveTermtwoCtrl",this.typefiveThreeFiveTermtwoCtrl)

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typefiveThreeFiveTermtwoCtrl.can_published_edit;

        };
    }
}





const typesixSixSevenTermtwo = 'typesixSixSevenTermtwo'
class TypesixSixSevenTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesixSixSevenTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesixSixSevenTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typesixSixSevenTermtwoCtrl.card_details;
			vm.full_data = this.typesixSixSevenTermtwoCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typesixSixSevenTermtwoCtrl.can_published_edit;

        };
    }
}


const type8to10term2cbse = 'type8to10term2cbse'
class Type8to10termtwocbse {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type8to10_term2cbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type8to10_term2cbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type8to10_term2cbseCtrl.card_details;
            vm.full_data = this.type8to10_term2cbseCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type8to10_term2cbseCtrl.can_published_edit;
        };
    }
}




const  typefiveOneTwoTermtwo = 'typefiveOneTwoTermtwo'
class TypefiveOneTwoTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveOneTwoTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveOneTwoTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveOneTwoTermtwoCtrl.card_details;
			vm.full_data = this.typefiveOneTwoTermtwoCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.typefiveOneTwoTermtwoCtrl.can_published_edit;

        };
    }
}
const typeoneTwoShjTermTwo = 'typeoneTwoShjTermTwo'
class TypeoneTwoShjTermTwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typeoneTwoShjTermTwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typeoneTwoShjTermTwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typeoneTwoShjTermTwoCtrl.card_details;
			vm.full_data = this.typeoneTwoShjTermTwoCtrl.full_data;
			console.log("this.typeoneTwoShjTermTwoCtrl",this.typeoneTwoShjTermTwoCtrl)

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typeoneTwoShjTermTwoCtrl.can_published_edit;

        };
    }

}


const type1to2tcscbsetermtwo = 'type1to2tcscbsetermtwo'

class TypeonetotwoTcstermTwo {

    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
console.log(vm,"type1to2_tcscbseterm2Ctrl---------");
        this.$onInit = function () {

            vm.allStudentReportData = this.type1to2_tcscbseterm2Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type1to2_tcscbseterm2Ctrl.sendForApprovalFlag;
            vm.card_details = this.type1to2_tcscbseterm2Ctrl.card_details;
            vm.full_data = this.type1to2_tcscbseterm2Ctrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type1to2_tcscbseterm2Ctrl.can_published_edit;
			console.log(vm.can_published_edit,"vm.can_published_edit===========");
        };
    }
}



const type6to7tcscbseterm2 = 'type6to7tcscbseterm2'
class Type6to7_termTcscbseterm2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type6to7_tcscbseterm2Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type6to7_tcscbseterm2Ctrl.sendForApprovalFlag;
            vm.card_details = this.type6to7_tcscbseterm2Ctrl.card_details;
            vm.full_data = this.type6to7_tcscbseterm2Ctrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type6to7_tcscbseterm2Ctrl.can_published_edit;
        };
    }
}



const type3to5tcscbseterm2 = 'type3to5tcscbseterm2'
class Type3to5_termTcscbseterm2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type3to5_tcscbseCtrltermtwo.allStudentReportData;
            vm.sendForApprovalFlag = this.type3to5_tcscbseCtrltermtwo.sendForApprovalFlag;
            vm.card_details = this.type3to5_tcscbseCtrltermtwo.card_details;
            vm.full_data = this.type3to5_tcscbseCtrltermtwo.full_data;
console.log(vm.full_data,"vm.full_data----------------");
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type3to5_tcscbseCtrltermtwo.can_published_edit;
        };
    }
}

const  typesixThreeFiveTermtwo = 'typesixThreeFiveTermtwo'
class TypesixThreeFiveTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesixThreeFiveTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesixThreeFiveTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typesixThreeFiveTermtwoCtrl.card_details;
			vm.full_data = this.typesixThreeFiveTermtwoCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typesixThreeFiveTermtwoCtrl.can_published_edit;

        };
    }
}

const typefiveSixSevenTermtwo = 'typefiveSixSevenTermtwo'
class TypefiveSixSevenTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveSixSevenTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveSixSevenTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveSixSevenTermtwoCtrl.card_details;
			vm.full_data = this.typefiveSixSevenTermtwoCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typefiveSixSevenTermtwoCtrl.can_published_edit;

        };
    }
}



const  typefiveEightTermtwo = 'typefiveEightTermtwo'
class TypefiveEightTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typefiveEightTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typefiveEightTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typefiveEightTermtwoCtrl.card_details;
			vm.full_data = this.typefiveEightTermtwoCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typefiveEightTermtwoCtrl.can_published_edit;

        };
    }
}
const type6to7alncbseterm2 = 'type6to7alncbseterm2'
class Type6to7_termAlncbseterm2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type6to7_alncbseCtrlterm2.allStudentReportData;
            vm.sendForApprovalFlag = this.type6to7_alncbseCtrlterm2.sendForApprovalFlag;
            vm.card_details = this.type6to7_alncbseCtrlterm2.card_details;
            vm.full_data = this.type6to7_alncbseCtrlterm2.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type6to7_alncbseCtrlterm2.can_published_edit;
        };
    }
}


const typesevenOneTwoTermtwo = 'typesevenOneTwoTermtwo'
class TypesevenOneTwoTermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
               let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			vm.allStudentReportData = this.typesevenOneTwoTermtwoCtrl.allStudentReportData;
			vm.sendForApprovalFlag = this.typesevenOneTwoTermtwoCtrl.sendForApprovalFlag;
			vm.card_details = this.typesevenOneTwoTermtwoCtrl.card_details;
			vm.full_data = this.typesevenOneTwoTermtwoCtrl.full_data;

			if(vm.full_data && vm.full_data.report_template){

                let card = vm.full_data.report_template
				// console.log()
				console.log(card,"77777777777777777")
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
			if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
			console.log(vm.card_details, vm.full_data, vm.is_specific,'===========')
            vm.can_published_edit = this.typesevenOneTwoTermtwoCtrl.can_published_edit;

        };
    }
}


const type3to5alnterm2cbse = 'type3to5alnterm2cbse'
class TypeThreeToFiveTermAlncbsetermtwo {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';

        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
			console.log("ppp0000------");
            vm.allStudentReportData = this.type3to5_alnterm2cbseCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type3to5_alnterm2cbseCtrl.sendForApprovalFlag;
            vm.card_details = this.type3to5_alnterm2cbseCtrl.card_details;
            vm.full_data = this.type3to5_alnterm2cbseCtrl.full_data;
            // let is25 = false
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            // is25 = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type3to5_alnterm2cbseCtrl.can_published_edit;
            // vm.is25 = is25
        };
    }
}

const typetermcbse8to10term2 = 'typetermcbse8to10term2'
class TypetermOnecbseterm2_8to10 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.typetermcbse_8to10term2Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typetermcbse_8to10term2Ctrl.sendForApprovalFlag;
            vm.card_details = this.typetermcbse_8to10term2Ctrl.card_details;
            vm.full_data = this.typetermcbse_8to10term2Ctrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.typetermcbse_8to10term2Ctrl.can_published_edit;
        };
    }
}
const typeptnoconv = 'typeptnoconv';
class TypePtNoConv {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
		vm.max_mark = undefined
        this.$onInit = function () {
            vm.allStudentReportData = this.typePtNoConvCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.typePtNoConvCtrl.sendForApprovalFlag;
            vm.card_details = this.typePtNoConvCtrl.card_details;

            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = _.find(vm.card_details, function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }

             vm.can_published_edit = this.typePtNoConvCtrl.can_published_edit;
            if (vm.allStudentReportData.results[0].marks.max_mark_data) {
                vm.max_mark = vm.allStudentReportData.results[0].marks.max_mark_data.periodic_test.max_mark
            }
            else {
                try {
                    vm.max_mark = vm.allStudentReportData["bucket_max_mark"]['periodic_test']['max_mark']
                } catch (error) {
                    console.log("Error in finding max mark");
                }
            }
        };
    }
}
const type25tcscbseOneFiveTerm2 = 'type25tcscbseOneFiveTerm2'
class Type25tcscbseOneFiveTerm2 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type25tcscbseOneFiveTerm2Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag;
            vm.card_details = this.type25tcscbseOneFiveTerm2Ctrl.card_details;
            vm.full_data = this.type25tcscbseOneFiveTerm2Ctrl.full_data;
console.log(vm.full_data,"vm.full_data----------------");
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type25tcscbseOneFiveTerm2Ctrl.can_published_edit;
        };
    }
}
const type25tcscbseOneFive = 'type25tcscbseOneFive'
class Type25tcscbseOneFive {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type25tcscbseOneFiveCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type25tcscbseOneFiveCtrl.sendForApprovalFlag;
            vm.card_details = this.type25tcscbseOneFiveCtrl.card_details;
            vm.full_data = this.type25tcscbseOneFiveCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false
                        }
                    }
            }
            console.log(vm.card_details, vm.full_data, vm.is_specific)
            vm.can_published_edit = this.type25tcscbseOneFiveCtrl.can_published_edit;
        };
    }
}

const typefiveonetwoGrdTerm1New26 = 'typefiveonetwoGrdTerm1New26'
class TypefiveonetwoGrdTerm1New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^__________^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^")
		console.log('=== NEW26 DEBUG: TypefiveonetwoGrdTerm1New26 CONSTRUCTOR called ===');
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.showScholasticTable = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type5_1_2_grade_term1_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type5_1_2_grade_term1_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type5_1_2_grade_term1_new26TemplateCtrl.card_details;
            vm.full_data = this.type5_1_2_grade_term1_new26TemplateCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type5_1_2_grade_term1_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const typefiveonetwoGrdTerm2New26 = 'typefiveonetwoGrdTerm2New26'
class TypefiveonetwoGrdTerm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.showScholasticTable = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type5_1_2_grade_term2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type5_1_2_grade_term2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type5_1_2_grade_term2_new26TemplateCtrl.card_details;
            vm.full_data = this.type5_1_2_grade_term2_new26TemplateCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type5_1_2_grade_term2_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const typefivethreefiveGrdTerm1New26 = 'typefivethreefiveGrdTerm1New26'
class TypefivethreefiveGrdTerm1New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.showScholasticTable = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type5_3_5_grade_term1_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type5_3_5_grade_term1_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type5_3_5_grade_term1_new26TemplateCtrl.card_details;
            vm.full_data = this.type5_3_5_grade_term1_new26TemplateCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const typefivethreefiveGrdTerm2New26 = 'typefivethreefiveGrdTerm2New26'
class TypefivethreefiveGrdTerm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.showScholasticTable = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type5_3_5_grade_term2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type5_3_5_grade_term2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type5_3_5_grade_term2_new26TemplateCtrl.card_details;
            vm.full_data = this.type5_3_5_grade_term2_new26TemplateCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const typesixsixsevenGrdTerm1New26 = 'typesixsixsevenGrdTerm1New26'
class TypesixsixsevenGrdTerm1New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.showScholasticTable = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type6_6_7_grade_term1_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type6_6_7_grade_term1_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type6_6_7_grade_term1_new26TemplateCtrl.card_details;
            vm.full_data = this.type6_6_7_grade_term1_new26TemplateCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const typesixsixsevenGrdTerm2New26 = 'typesixsixsevenGrdTerm2New26'
class TypesixsixsevenGrdTerm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined
        vm.is_specific = false
        vm.additional_subjects = false
        vm.showScholasticTable = false
        this.$onInit = function () {
            vm.allStudentReportData = this.type6_6_7_grade_term2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type6_6_7_grade_term2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type6_6_7_grade_term2_new26TemplateCtrl.card_details;
            vm.full_data = this.type6_6_7_grade_term2_new26TemplateCtrl.full_data;

            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type8to10TermcbseNew26 = 'type8to10TermcbseNew26'
class Type8to10TermcbseNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type8to10_termcbse_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type8to10_termcbse_new26TemplateCtrl.card_details;
            vm.full_data = this.type8to10_termcbse_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type8to10_termcbse_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type8to10Termcbseterm2New26 = 'type8to10Termcbseterm2New26'
class Type8to10Termcbseterm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type8to10_termcbseterm2_new26TemplateCtrl.card_details;
            vm.full_data = this.type8to10_termcbseterm2_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}
const type9TermcbseNew26 = 'type9TermcbseNew26'
class Type9TermcbseNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type9_termcbse_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type9_termcbse_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type9_termcbse_new26TemplateCtrl.card_details;
            vm.full_data = this.type9_termcbse_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type9_termcbse_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type9Termcbseterm2New26 = 'type9Termcbseterm2New26'
class Type9Termcbseterm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type9_termcbseterm2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type9_termcbseterm2_new26TemplateCtrl.card_details;
            vm.full_data = this.type9_termcbseterm2_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = false   // bug 28032: an additional subject is NOT a specific subject;
                                                     // leaving this true rendered BOTH template sections
                        }
                    }
            }
            vm.can_published_edit = this.type9_termcbseterm2_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type10TermcbseNew26 = 'type10TermcbseNew26'
class Type10TermcbseNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type10_termcbse_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type10_termcbse_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type10_termcbse_new26TemplateCtrl.card_details;
            vm.full_data = this.type10_termcbse_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type10_termcbse_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type10Termcbseterm2New26 = 'type10Termcbseterm2New26'
class Type10Termcbseterm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type10_termcbseterm2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type10_termcbseterm2_new26TemplateCtrl.card_details;
            vm.full_data = this.type10_termcbseterm2_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.specific_subjects.activity_buckets
                            vm.is_specific = true
                            vm.additional_subjects = false
                        }
                    }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects &&
                    card.additional_subjects.subjects && card.additional_subjects.subjects.length){
                        if(card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.card_details = card.additional_subjects.activity_buckets
                            vm.additional_subjects = true
                            vm.is_specific = true
                        }
                    }
            }
            vm.can_published_edit = this.type10_termcbseterm2_new26TemplateCtrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type10KbGradeTerm1New26 = 'type10KbGradeTerm1New26'
class Type10KbGradeTerm1New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.content_mngr = {
            is_specific: false,
            subject_40_subjects: false,
            subject_80_subjects: true
        };
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type10KbGradeTerm1New26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type10KbGradeTerm1New26Ctrl.sendForApprovalFlag;
            vm.card_details = this.type10KbGradeTerm1New26Ctrl.card_details;
            vm.full_data = this.type10KbGradeTerm1New26Ctrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template;
                let cardSchoolId = vm.allStudentReportData && vm.allStudentReportData.report_card_header
                    ? vm.allStudentReportData.report_card_header.school_id
                    : null;
                if(card.subject_40_subjects && card.subject_40_subjects &&
                    card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length){
                        if(card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific: false,
                                subject_40_subjects: true,
                                subject_80_subjects: false
                            };
                            vm.card_details = card.subject_40_subjects.activity_buckets;
                        }
                }
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific: true,
                                subject_40_subjects: false,
                                subject_80_subjects: false
                            };
                            vm.card_details = card.specific_subjects.activity_buckets;
                            if (cardSchoolId == 'ps4vyLJhQvPZjfxaH' && vm.card_details) {
                                vm.card_details = vm.card_details.map(function (b) {
                                    b.max_mark = 100;
                                    return b;
                                });
                            }
                        }
                }
            }
            vm.can_published_edit = this.type10KbGradeTerm1New26Ctrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}

const type10KbGradeTerm2New26 = 'type10KbGradeTerm2New26'
class Type10KbGradeTerm2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.content_mngr = {
            is_specific: false,
            subject_40_subjects: false,
            subject_80_subjects: true
        };
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type10KbGradeTerm2New26Ctrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type10KbGradeTerm2New26Ctrl.sendForApprovalFlag;
            vm.card_details = this.type10KbGradeTerm2New26Ctrl.card_details;
            vm.full_data = this.type10KbGradeTerm2New26Ctrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template;
                let cardSchoolId = vm.allStudentReportData && vm.allStudentReportData.report_card_header
                    ? vm.allStudentReportData.report_card_header.school_id
                    : null;
                if(card.subject_40_subjects && card.subject_40_subjects &&
                    card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length){
                        if(card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific: false,
                                subject_40_subjects: true,
                                subject_80_subjects: false
                            };
                            vm.card_details = card.subject_40_subjects.activity_buckets;
                        }
                }
                if(card.specific_subjects && card.specific_subjects &&
                    card.specific_subjects.subjects && card.specific_subjects.subjects.length){
                        if(card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1){
                            vm.content_mngr = {
                                is_specific: true,
                                subject_40_subjects: false,
                                subject_80_subjects: false
                            };
                            vm.card_details = card.specific_subjects.activity_buckets;
                            if (cardSchoolId == 'ps4vyLJhQvPZjfxaH' && vm.card_details) {
                                vm.card_details = vm.card_details.map(function (b) {
                                    b.max_mark = 100;
                                    return b;
                                });
                            }
                        }
                }
            }
            vm.can_published_edit = this.type10KbGradeTerm2New26Ctrl.can_published_edit;
            vm.showScholasticTable = true;
        };
    }
}
const type02Grade11ScienceNew26 = 'type02Grade11ScienceNew26'
class Type02Grade11ScienceNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade_11_science_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type02grade_11_science_new26TemplateCtrl.card_details;
            vm.full_data = this.type02grade_11_science_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subjects && card.type9_specific_subjects.subjects &&
                    card.type9_specific_subjects.subjects.length){
                    if(card.type9_specific_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.type9_specific_subjects.activity_buckets
                        vm.is_specific = true
                        vm.additional_subjects = false
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects.subjects &&
                    card.additional_subjects.subjects.length){
                    if(card.additional_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.additional_subjects.activity_buckets
                        vm.additional_subjects = true
                        vm.is_specific = true
                    }
                }
            }
            vm.can_published_edit = this.type02grade_11_science_new26TemplateCtrl.can_published_edit;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = (vm.card_details || []).find(function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            vm.showScholasticTable = true;
        };
    }
}

const type02Grade11Sciencet2New26 = 'type02Grade11Sciencet2New26'
class Type02Grade11Sciencet2New26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type02grade_11_sciencet2_new26TemplateCtrl.card_details;
            vm.full_data = this.type02grade_11_sciencet2_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subjects && card.type9_specific_subjects.subjects &&
                    card.type9_specific_subjects.subjects.length){
                    if(card.type9_specific_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.type9_specific_subjects.activity_buckets
                        vm.is_specific = true
                        vm.additional_subjects = false
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects.subjects &&
                    card.additional_subjects.subjects.length){
                    if(card.additional_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.additional_subjects.activity_buckets
                        vm.additional_subjects = true
                        vm.is_specific = true
                    }
                }
            }
            vm.can_published_edit = this.type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = (vm.card_details || []).find(function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            vm.showScholasticTable = true;
        };
    }
}
const type02Grade12ScienceNew26 = 'type02Grade12ScienceNew26'
class Type02Grade12ScienceNew26 {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade_12_science_new26TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type02grade_12_science_new26TemplateCtrl.card_details;
            vm.full_data = this.type02grade_12_science_new26TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subjects && card.type9_specific_subjects.subjects &&
                    card.type9_specific_subjects.subjects.length){
                    if(card.type9_specific_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.type9_specific_subjects.activity_buckets
                        vm.is_specific = true
                        vm.additional_subjects = false
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects.subjects &&
                    card.additional_subjects.subjects.length){
                    if(card.additional_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.additional_subjects.activity_buckets
                        vm.additional_subjects = true
                        vm.is_specific = true
                    }
                }
            }
            vm.can_published_edit = this.type02grade_12_science_new26TemplateCtrl.can_published_edit;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = (vm.card_details || []).find(function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            vm.showScholasticTable = true;
        };
    }
}
const type02Grade12Sciencet2New = 'type02Grade12Sciencet2New'
class Type02Grade12Sciencet2New {
    constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
        'ngInject';
        let vm = this;
        vm.allStudentReportData = undefined;
        vm.card_details = undefined;
        vm.full_data = undefined;
        vm.is_specific = false;
        vm.additional_subjects = false;
        vm.showScholasticTable = false;
        this.$onInit = function () {
            vm.allStudentReportData = this.type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData;
            vm.sendForApprovalFlag = this.type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag;
            vm.card_details = this.type02grade_12_sciencet2_new_TemplateCtrl.card_details;
            vm.full_data = this.type02grade_12_sciencet2_new_TemplateCtrl.full_data;
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.type9_specific_subjects && card.type9_specific_subjects.subjects &&
                    card.type9_specific_subjects.subjects.length){
                    if(card.type9_specific_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.type9_specific_subjects.activity_buckets
                        vm.is_specific = true
                        vm.additional_subjects = false
                    }
                }
            }
            if(vm.full_data && vm.full_data.report_template){
                let card = vm.full_data.report_template
                if(card.additional_subjects && card.additional_subjects.subjects &&
                    card.additional_subjects.subjects.length){
                    if(card.additional_subjects.subjects.indexOf(
                        vm.allStudentReportData.academic_details.subject_id) !== -1){
                        vm.card_details = card.additional_subjects.activity_buckets
                        vm.additional_subjects = true
                        vm.is_specific = true
                    }
                }
            }
            vm.can_published_edit = this.type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit;
            if(vm.allStudentReportData.bucket_max_mark){
                let keys = Object.keys(vm.allStudentReportData.bucket_max_mark)
                for(let k = 0; k < keys.length; k++){
                    let bucket = (vm.card_details || []).find(function(one){
                        return one.db_key == keys[k]
                    })
                    if(bucket){
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark']
                    }
                }
            }
            vm.showScholasticTable = true;
        };
    }
}

// create a module
export default angular.module(name, [
])
    .component(name, {
        template: templateMain,
        controllerAs: "generatedViewCtrl",
        controller: reportGeneratedViewController
    })
    .component(typeOneMarkComponent, {
        template: typeOneMarkComponentTemplate,
        transclude: true,
        require: {
            typeOneMarkTemplateCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeOneMarkCtrl",
        controller: TypeOneMarkClass
    })
    .component(typeTwoMarkComponent, {
        template: typeTwoMarkComponentTemplate,
        transclude: true,
        require: {
            typeTwoMarkTemplateCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeTwoMarkCtrl",
        controller: TypeTwoMarkClass
    })
    .component(typeThreeSubSkillComponent, {
        template: typeThreeSubSkillComponentTemplate,
        transclude: true,
        require: {
            typeThreeSubSkillCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeThreeMarkCtrl",
        controller: TypeThreeSubSkillClass
    })
    .component(typeSkillOnlyComponent, {
        template: skill_onlyTemplate,
        transclude: true,
        require: {
            typeSkillOnlyComponentCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeSkillOnlyCtrl",
        controller: TypeSkillOnlyClass
    })
    .component(typeOneGradeComponent, {
        template: typeOneGradeComponentTemplate,
        transclude: true,
        require: {
            typeOneGradeComponentCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeOneGradeCtrl",
        controller: TypeOneGradeComponentClass
    })
    .component(periodicTestDeafaultHFcomponent, {
        template: periodicTestDeafaultHFTemplate,
        transclude: true,
        require: {
            periodicTestDeafaultHFCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "pTdefaultHFCtrl",
        controller: PeriodicTestDeafaultHFClass
    })
    .component(periodicTestDeafaultAnnualcomponent, {
        template: periodicTestDeafaultANNUALTemplate,
        transclude: true,
        bindings: true,
        require: {
            periodicTestDeafaultAnnualCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "pTdefaultAnnualCtrl",
        controller: PeriodicTestDeafaultAnnualClass
    })
    .component(typeFourMarkComponent, {
        template: typeFourMarkTemplate,
        transclude: true,
        bindings: true,
        require: {
            typeFourMarkTemplateCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeFourMarkCtrl",
        controller: TypeFourMarkComponent
    })
    .component(typeFourAnnualComponent, {
        template: typeFourAnnualTemplate,
        transclude: true,
        bindings: true,
        require: {
            typeFourAnnualTemplateCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeFourAnnualCtrl",
        controller: TypeFourAnnualComponent
    })
    .component(periodicTestDeafaultHFTwocomponent, {
        template: periodicTestDeafaultHFTwoTemplate,
        transclude: true,
        bindings: true,
        require: {
            periodicTestDefaultHfTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "periodicTestDefaultHfTwoCtrl",
        controller: PeriodicTestDefaultHfTwoClass
    })
    .component(periodicTestDefaultAnnualTwocomponent, {
        template: periodicTestDefaultAnnualTwoTemplate,
        transclude: true,
        bindings: true,
        require: {
            periodicTestDefaultAnnualTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "periodicTestDefaultAnnualTwoCtrl",
        controller: PeriodicTestDefaultAnnualTwoClass
    })
    .component(hssTemplateComponent, {
        template: hssTemplate,
        transclude: true,
        bindings: true,
        require: {
            hssTemplateComponentCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "hssTemplateComponentCtrl",
        controller: HssTemplateComponentClass
    })
    .component(cbsehssComponent, {
        template: cbse_hssTemplate,
        transclude: true,
        bindings: true,
        require: {
            cbsehssComponentCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "cbsehssComponentCtrl",
        controller: CbsehssClass
    })
    .component(kbhfhssComp, {
        template: kbHssTermOneHalfYearlyTemplate,
        transclude: true,
        bindings: true,
        require: {
            kbhfhssCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "kbhfhssCompCtrl",
        controller: KbhfhssCompClass
    })
    .component(termonehalfyearlyComp, {
        template: termOneHalfYearlyTemplate,
        transclude: true,
        bindings: true,
        require: {
            termonehalfyearlyCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "termonehalfyearlyCompCtrl",
        controller: TermonehalfyearlyCompClass
    })
    .component(gradeNineComp, {
        template: grade9Template,
        transclude: true,
        bindings: true,
        require: {
            gradeNineCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "gradeNineAnnualCompCtrl",
        controller: gradeNineCompClass
    })
    .component(gradeOneEightComp, {
        template: grade1_8AnnTemplate,
        transclude: true,
        bindings: true,
        require: {
            gradeOneEightCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "gradeOneEightCompCtrl",
        controller: GradeOneEightCompClass
    })
    .component(annualCbseHssComp, {
        template: annualCbsehssTEMPLATE,
        transclude: true,
        require: {
            annualCbseHssCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "annualCbseHssCompCtrl",
        controller: AnnualCbseHssCompClass
    })
    .component(annualNineOnlyComp, {
        template: nineAnnualOnlyTemplate,
        transclude: true,
        bindings: true,
        require: {
            annualNineOnlyCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "annualNineOnlyCompCtrl",
        controller: AnnualNineOnlyClass
    })
    .component(kbannualComponent, {
        template: KB_annual_Template,
        transclude: true,
        bindings: true,
        require: {
            kbannualComponentCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "kbannualComponentCtrl",
        controller: KbannualComponentClass
    })
    .component(kbhfComponent, {
        template: KB_PT_HF_template,
        transclude: true,
        bindings: true,
        require: {
            kbhfPtCompCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "kbhfPtCompCtrl",
        controller: KbhfCompClass
    })
    .component(halfyearlyExam, {
        template: CALICUT_HF_EXAM,
        transclude: true,
        bindings: true,
        require: {
            halfyearlyExamCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "halfyearlyExamCtrl",
        controller: HalfyearlyExam
    })
    .component(typefiveNineTen, {
        template: type_5_9_10_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveNineTenCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefiveNineTenCtrl",
        controller: TypefiveNineTen
    })
    .component(typefiveNineTenTermTwo, {
        template: type_5_9_10_templateTerm2,
        transclude: true,
        bindings: true,
        require: {
            typefiveNineTenTermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefiveNineTenTermTwoCtrl",
        controller: TypefiveNineTenTermTwo
    })

    .component(typefiveSixEightTermone, {
        template: type_5_6_8_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveSixEightTerm1Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefiveSixEightTerm1Ctrl",
        controller: TypefiveSixEightTerm1
    })
    .component(typefiveSixEightTermtwo, {
        template: type_5_6_8_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveSixEightTerm2Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefiveSixEightTerm2Ctrl",
        controller: TypefiveSixEightTerm2
    })
    .component(typefiveOneFiveTermone, {
        template: type_5_1_5_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveOneFiveTermoneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefiveOneFiveTermoneCtrl",
        controller: TypefiveOneFiveTermone
    })
    .component(typefiveOneFiveTermtwo, {
        template: type_5_1_5_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveOneFiveTermtwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefiveOneFiveTermtwoCtrl",
        controller: TypefiveOneFiveTermtwo
    })

    .component(typefivekbtenTermOne, {
        template: type_5_10_Kb_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefivekbtenTermOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefivekbtenTermOneCtrl",
        controller: TypefivekbtenTermOne
    })
    .component(typefivekbtenTermTwo, {
        template: type_5_10_Kb_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefivekbtenTermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefivekbtenTermTwoCtrl",
        controller: TypefivekbtenTermTwo
    })
    .component(typefivekbEightNineTermOne, {
        template: type_5_8_9_Kb_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefivekbEightNineTermOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefivekbEightNineTermOneCtrl",
        controller: TypefivekbEightNineTermOne
    })
    .component(typefivekbEightNineTermTwo, {
        template: type_5_8_9_Kb_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefivekbEightNineTermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefivekbEightNineTermTwoCtrl",
        controller: TypefivekbEightNineTermTwo
    })
    .component(typefivekbEightNineTermThree, {
        template: type_5_8_9_Kb_Term3_template,
        transclude: true,
        bindings: true,
        require: {
            typefivekbEightNineTermThreeCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typefivekbEightNineTermThreeCtrl",
        controller: TypefivekbEightNineTermThree
    })
    .component(typesixModelExamTermOne, {
        template: type_6_model_exam_1_template,
        transclude: true,
        bindings: true,
        require: {
            typeSixModelExamOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeSixModelExamOneCtrl",
        controller: TypeSixModelExamOne
    })
    .component(typesixModelExamTermOnenineten, {
        template: type_6_model_exam_1nineten_template,
        transclude: true,
        bindings: true,
        require: {
            typesixModelExamTermOneninetenCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typesixModelExamTermOneninetenCtrl",
        controller: TypesixModelExamTermOnenineten
    })
    .component(typesixModelExamTermTwonineten, {
        template: type_6_model_exam_2nineten_template,
        transclude: true,
        bindings: true,
        require: {
            typesixModelExamTermTwoninetenCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typesixModelExamTermTwoninetenCtrl",
        controller: TypesixModelExamTermTwonineten
    })
    .component(typesixModelExamTermTwoNospace, {
        template: type_6_model_exam_2_template,
        transclude: true,
        bindings: true,
        require: {
            typesixModelExamTermTwoNospaceCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typesixModelExamTermTwoNospaceCtrl",
        controller: TypesixModelExamTermTwoNospace
    })
    .component(typesixModelAnnualExamTerm, {
        template: type_6_model_annualexam_2_template,
        transclude: true,
        bindings: true,
        require: {
            typesixModelAnnualExamTermCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typesixModelAnnualExamTermCtrl",
        controller: TypesixModelAnnualExamTerm
    })
    .component(typeSevenCalicultAnnual, {
        template: type_7calicut_annual_template,
        transclude: true,
        bindings: true,
        require: {
            typeSevenCalicultAnnualCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeSevenCalicultAnnualCtrl",
        controller: TypeSevenCalicultAnnual
    })
    .component(typeNinePT, {
        template: type9_cbse_pt1_template,
        transclude: true,
        bindings: true,
        require: {
            typeNinePTCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNinePTCtrl",
        controller: TypeNinePT
    })
    .component(typeNineTermOneHF, {
        template: type9_cbse_hf1_template,
        transclude: true,
        bindings: true,
        require: {
            typeNineTermOneHFCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNineTermOneHFCtrl",
        controller: TypeNineTermOneHF
    })
    .component(typeNineTermAe, {
        template: type9_cbse_term2_ae_template,
        transclude: true,
        bindings: true,
        require: {
            typeNineTermAeCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNineTermAeCtrl",
        controller: TypeNineTermAe
    })
    .component(typeNineTwelveTermAe, {
        template: type9_grade12term2_ae_template,
        transclude: true,
        bindings: true,
        require: {
            typeNineTwelveTermAeCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNineTwelveTermAeCtrl",
        controller: TypeNineTwelveTermAe
    })
    .component(typeNinekbUnitTestOne, {
        template: type9_kb_unit_test1_template,
        transclude: true,
        bindings: true,
        require: {
            typeNinekbUnitTestOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNinekbUnitTestOneCtrl",
        controller: TypeNinekbUnitTestOne
    })
    .component(typeNineKbtermOnehf, {
        template: type9_kbterm1_hf_template,
        transclude: true,
        bindings: true,
        require: {
            typeNineKbtermOnehfCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNineKbtermOnehfCtrl",
        controller: TypeNineKbtermOnehf
    })
    .component(typeNineKbtermTwo, {
        template: type9_kbterm2_template,
        transclude: true,
        bindings: true,
        require: {
            typeNineKbtermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNineKbtermTwoCtrl",
        controller: TypeNineKbtermTwo
    })
    .component(typeNinekbTermThreeCtrl, {
        template: type9_kbterm3_template,
        transclude: true,
        bindings: true,
        require: {
            typeNinekbTermThreeCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typeNinekbTermThreeCtrl",
        controller: TypeNinekbTermThreeCtrl
    })
    .component(type12termcbse, {
        template: type12term1cbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type12_termcbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type12_termcbseCtrl",
        controller: Type12_termcbse
    })
    .component(type12NineTentermcbse, {
        template: type12NineTentermcbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type12NineTentermcbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type12NineTentermcbseCtrl",
        controller: Type12NineTentermcbse
    })
    .component(eltPublishedReport, {
        template: eltReportTemplate,
        transclude: true,
        bindings: true,
        require: {
            eltPublishedReportCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "eltPublishedReportCtrl",
        controller: EltPublishedReport
    })
    .component(type20kb10Gradeterm1, {
        template: type20_KB_10_grade_term1Temp,
        transclude: true,
        bindings: true,
        require: {
            type20kb10Gradeterm1Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type20kb10Gradeterm1Ctrl",
        controller: Type20kb10Gradeterm1Ctrl
    })
    .component(type20termcbse, {
        template: type20term1cbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type20_termcbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type20_termcbseCtrl",
        controller: Type20_termcbse
    })
    .component(type20termcbse18, {
        template: type20term1cbse18Template,
        transclude: true,
        bindings: true,
        require: {
            type20_termcbse18Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type20_termcbse18Ctrl",
        controller: Type20_termcbse18
    })
    .component(type20term2cbse, {
        template: type20term2cbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type20_term2cbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type20_term2cbseCtrl",
        controller: Type20_term2cbse
    })
    .component(type20term2cbse18, {
        template: type20_term2cbse18Template,
        transclude: true,
        bindings: true,
        require: {
            type20_term2cbse18Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type20_term2cbse18Ctrl",
        controller: Type20_termtwocbse18
    }).component(typefiveSixSevenTermone, {
        template:type_5_6_7_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveSixSevenTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveSixSevenTermoneCtrl",
        controller: TypefiveSixSevenTermone

    }).component(typesixSixSevenTermone, {
        template:type_6_6_7_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typesixSixSevenTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesixSixSevenTermoneCtrl",
        controller: TypesixSixSevenTermone

    }).component(typefiveOneTwoTermone, {
        template:type_5_1_2_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveOneTwoTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveOneTwoTermoneCtrl",
        controller: TypefiveOneTwoTermone

    }).component(typesixOneTwoTermone, {
        template:type_6_1_2_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typesixOneTwoTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesixOneTwoTermoneCtrl",
        controller: TypesixOneTwoTermone

    }).component(typesixThreeFiveTermone, {
        template:type_6_3_5_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typesixThreeFiveTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesixThreeFiveTermoneCtrl",
        controller: TypesixThreeFiveTermone

    })
	.component(typefiveEightTermone, {
        template:type_5_8_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveEightTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveEightTermoneCtrl",
        controller: TypefiveEightTermone

    }).component(typefiveThreeFiveTermone, {
        template:type_5_3_5_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveThreeFiveTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveThreeFiveTermoneCtrl",
        controller: TypefiveThreeFiveTermone

    })

    .component(type20kb10Gradeterm2, {
        template: type20_KB_10_grade_term2Temp,
        transclude: true,
        bindings: true,
        require: {
            type20kb10Gradeterm2Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type20kb10Gradeterm2Ctrl",
        controller: Type20kb10Gradeterm2Ctrl
    })
    .component(typethirtykbtenTermOne, {
        template: type_30_89Kb_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typethirtykbtenTermOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typethirtykbtenTermOneCtrl",
        controller: TypethirtykbtenTermOne
    })
    .component(typethirtykbtenTermTwo, {
        template: type_30_89Kb_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typethirtykbtenTermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typethirtykbtenTermTwoCtrl",
        controller: TypethirtykbtenTermTwo
    })
    .component(typethirtykbtenTermThree, {
        template: type_30_89Kb_Term3_template,
        transclude: true,
        bindings: true,
        require: {
            typethirtykbtenTermThreeCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typethirtykbtenTermThreeCtrl",
        controller: TypethirtykbtenTermThree
    })
    .component(typethirtykbtenTermOneNew26, {
        template: type_30_89Kb_Term1_new26_template,
        transclude: true,
        bindings: true,
        require: {
            typethirtykbtenTermOneNew26Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typethirtykbtenTermOneNew26Ctrl",
        controller: TypethirtykbtenTermOneNew26
    })
    .component(typethirtykbtenTermTwoNew26, {
        template: type_30_89Kb_Term2_new26_template,
        transclude: true,
        bindings: true,
        require: {
            typethirtykbtenTermTwoNew26Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typethirtykbtenTermTwoNew26Ctrl",
        controller: TypethirtykbtenTermTwoNew26
    })
    .component(typethirtykbtenTermThreeNew26, {
        template: type_30_89Kb_Term3_new26_template,
        transclude: true,
        bindings: true,
        require: {
            typethirtykbtenTermThreeNew26Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typethirtykbtenTermThreeNew26Ctrl",
        controller: TypethirtykbtenTermThreeNew26
    })

    .component(type8to10termcbse, {
        template: type8to10_termcbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type8to10_termcbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type8to10_termcbseCtrl",
        controller: Type8to10_termOnecbse
    })
    .component(typetermcbse8to10, {
        template: typetermcbse_8to10Template,
        transclude: true,
        bindings: true,
        require: {
            typetermcbse_8to10Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetermcbse_8to10Ctrl",
        controller: TypetermOnecbse_8to10
    })
    .component(type6to7alncbse, {
        template: type6to7_alncbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type6to7_alncbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type6to7_alncbseCtrl",
        controller: Type6to7_termAlncbse
    })
    .component(type6to7tcscbse, {
        template: type6to7_tcscbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type6to7_tcscbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type6to7_tcscbseCtrl",
        controller: Type6to7_termTcscbse
    })
    .component(type3to5tcscbse, {
        template: type3to5_tcscbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type3to5_tcscbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type3to5_tcscbseCtrl",
        controller: Type3to5_termTcscbse
    }).component(typesevenOneTwoTermone, {
        template:type_7_1_2_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typesevenOneTwoTermoneCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesevenOneTwoTermoneCtrl",
        controller: TypesevenOneTwoTermone

    })
    .component(type3to5alncbse, {
        template: type3to5_alncbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type3to5_alncbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type3to5_alncbseCtrl",

        controller: Type3to5_termAlncbse
    })
    .component(type1to2tcscbse, {
        template: type1to2_tcscbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type1to2_tcscbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type1to2_tcscbseCtrl",
        controller: Type1to2_termTcscbse
    }).component(typetenkbtenTermOne, {
        template: type_10_KB_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typetenkbtenTermOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetenkbtenTermOneCtrl",
        controller: TypetenkbTermOne
    }).component(typetenkbtenTermTwo, {
        template: type_10_KB_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typetenkbtenTermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetenkbtenTermTwoCtrl",
        controller: TypetenkbTermTwo
    }).component(typetenkbeleventwelveTermOne, {
        template: type_10_11_12_KB_Term1_template,
        transclude: true,
        bindings: true,
        require: {
            typetenkbeleventwelveTermOneCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetenkbeleventwelveTermOneCtrl",
        controller: TypetenkbeleventwelveTermOne
    }).component(typetenkbeleventwelveTermTwo, {
        template: type_10_11_12_KB_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typetenkbeleventwelveTermTwoCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetenkbeleventwelveTermTwoCtrl",
        controller: TypetenkbeleventwelveTermTwo
    }).component(typetenkbeleventwelveTermOneNew26, {
        template: type_10_11_12_KB_Term1_new26_template,
        transclude: true,
        bindings: true,
        require: {
            typetenkbeleventwelveTermOneNew26Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetenkbeleventwelveTermOneNew26Ctrl",
        controller: TypetenkbeleventwelveTermOneNew26
    }).component(typetenkbeleventwelveTermTwoNew26, {
        template: type_10_11_12_KB_Term2_new26_template,
        transclude: true,
        bindings: true,
        require: {
            typetenkbeleventwelveTermTwoNew26Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetenkbeleventwelveTermTwoNew26Ctrl",
        controller: TypetenkbeleventwelveTermTwoNew26
    }).component(type02grade11sc, {
        template: type02grade_11_ScienceTemplate,
        transclude: true,
        bindings: true,
        require: {
            type02grade11scCtrl: '^viewGeneratedReportData'
        },

        controllerAs: "type02grade11scCtrl",
        controller: Type02grade11sc
    }).component(type02grade11sct2, {
        template: type02grade_11_ScienceT2Template,
        transclude: true,
        bindings: true,
        require: {
            type02grade11sct2Ctrl: '^viewGeneratedReportData'
        },

        controllerAs: "type02grade11sct2Ctrl",
        controller: Type02grade11sct2
    }).component(type02grade12sc, {
        template: type02grade_12_ScienceTemplate,
        transclude: true,
        bindings: true,
        require: {
            type02grade12scCtrl: '^viewGeneratedReportData'
        },

        controllerAs: "type02grade12scCtrl",
        controller: Type02grade12sc
    }).component(type02grade12sct2, {
        template: type02grade_12_ScienceT2Template,
        transclude: true,
        bindings: true,
        require: {
            type02grade12sct2Ctrl: '^viewGeneratedReportData'
        },

        controllerAs: "type02grade12sct2Ctrl",
        controller: Type02grade12sct2
    }).component(typefiveThreeFiveTermtwo, {
        template:type_5_3_5_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveThreeFiveTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveThreeFiveTermtwoCtrl",
        controller: TypefiveThreeFiveTermtwo

    }).component(typesixSixSevenTermtwo, {
        template:type_6_6_7_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typesixSixSevenTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesixSixSevenTermtwoCtrl",
        controller: TypesixSixSevenTermtwo
    }).component(typeoneTwoShjTermTwo, {
        template:type_1to2shjcbset2_template,
        transclude: true,
        bindings: true,
        require: {
            typeoneTwoShjTermTwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typeoneTwoShjTermTwoCtrl",
        controller: TypeoneTwoShjTermTwo

    }) .component(type8to10term2cbse, {
        template: type8to10_term2cbseTemplate,
        transclude: true,
        bindings: true,
        require: {
            type8to10_term2cbseCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type8to10_term2cbseCtrl",
        controller: Type8to10termtwocbse
    }).component(typefiveOneTwoTermtwo, {
        template:type_5_1_2_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveOneTwoTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveOneTwoTermtwoCtrl",
        controller: TypefiveOneTwoTermtwo

    }).component(type1to2tcscbsetermtwo, {
        template: type1to2_tcscbseterm2Template,
        transclude: true,
        bindings: true,
        require: {
            type1to2_tcscbseterm2Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type1to2_tcscbseterm2Ctrl",
        controller: TypeonetotwoTcstermTwo
    }).component(type6to7tcscbseterm2, {
        template: type6to7_tcscbseterm2Template,
        transclude: true,
        bindings: true,
        require: {
            type6to7_tcscbseterm2Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type6to7_tcscbseterm2Ctrl",
        controller: Type6to7_termTcscbseterm2
    }).component(type3to5tcscbseterm2, {
        template: type3to5_tcscbseterm2Template,
        transclude: true,
        bindings: true,
        require: {
            type3to5_tcscbseCtrltermtwo: '^viewGeneratedReportData'
        },
        controllerAs: "type3to5_tcscbseCtrltermtwo",
        controller: Type3to5_termTcscbseterm2
    }).component(typesixThreeFiveTermtwo, {
        template:type_6_3_5_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typesixThreeFiveTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesixThreeFiveTermtwoCtrl",
        controller: TypesixThreeFiveTermtwo

    }).component(typefiveSixSevenTermtwo, {
        template:type_5_6_7_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveSixSevenTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveSixSevenTermtwoCtrl",
        controller: TypefiveSixSevenTermtwo

    }).component(typefiveEightTermtwo, {
        template:type_5_8_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typefiveEightTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typefiveEightTermtwoCtrl",
        controller: TypefiveEightTermtwo

    }).component(typesevenOneTwoTermtwo, {
        template:type_7_1_2_Term2_template,
        transclude: true,
        bindings: true,
        require: {
            typesevenOneTwoTermtwoCtrl: '^viewGeneratedReportData'

        },
        controllerAs: "typesevenOneTwoTermtwoCtrl",
        controller: TypesevenOneTwoTermtwo

    }).component(type3to5alnterm2cbse, {
		template: type3to5_alncbseterm2Template,
		transclude: true,
		bindings: true,
		require: {
			type3to5_alnterm2cbseCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type3to5_alnterm2cbseCtrl",
		controller: TypeThreeToFiveTermAlncbsetermtwo
	})
    .component(type6to7alncbseterm2, {
        template: type6to7_alncbse_term2Template,
        transclude: true,
        bindings: true,
        require: {
            type6to7_alncbseCtrlterm2: '^viewGeneratedReportData'
        },
        controllerAs: "type6to7_alncbseCtrlterm2",
        controller: Type6to7_termAlncbseterm2
    }) .component(typetermcbse8to10term2, {
        template: typetermcbse_8to10term2Template,
        transclude: true,
        bindings: true,
        require: {
            typetermcbse_8to10term2Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "typetermcbse_8to10term2Ctrl",
        controller: TypetermOnecbseterm2_8to10
    })
    .component(typeptnoconv, {
        template: pt_1_no_convTemplate,
        transclude: true,
        bindings: true,
        require: {
            typePtNoConvCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "typePtNoConvCtrl",
        controller: TypePtNoConv
    })
    .component(type25tcscbseOneFive, {
        template: type1to5_tcscbse_new,
        transclude: true,
        bindings: true,
        require: {
            type25tcscbseOneFiveCtrl: '^viewGeneratedReportData'
        },
        controllerAs: "type25tcscbseOneFiveCtrl",
        controller: Type25tcscbseOneFive
    })
    .component(type25tcscbseOneFiveTerm2, {
        template: type1to5_tcscbseterm2_new,
        transclude: true,
        bindings: true,
        require: {
            type25tcscbseOneFiveTerm2Ctrl: '^viewGeneratedReportData'
        },
        controllerAs: "type25tcscbseOneFiveTerm2Ctrl",
        controller: Type25tcscbseOneFiveTerm2
    })
	.component(type9TermcbseNew26, {
		template: type_9_termcbse_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type9_termcbse_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type9_termcbse_new26TemplateCtrl",
		controller: Type9TermcbseNew26
	})
	.component(type9Termcbseterm2New26, {
		template: type_9_termcbseterm2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type9_termcbseterm2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type9_termcbseterm2_new26TemplateCtrl",
		controller: Type9Termcbseterm2New26
	})
	.component(type10TermcbseNew26, {
		template: type_10_termcbse_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type10_termcbse_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type10_termcbse_new26TemplateCtrl",
		controller: Type10TermcbseNew26
	})
	.component(type10Termcbseterm2New26, {
		template: type_10_termcbseterm2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type10_termcbseterm2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type10_termcbseterm2_new26TemplateCtrl",
		controller: Type10Termcbseterm2New26
	})


	// NEW26 Component Registrations
	.component(typefiveonetwoGrdTerm1New26, {
		template: type_5_1_2_Term1_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type5_1_2_grade_term1_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type5_1_2_grade_term1_new26TemplateCtrl",
		controller: TypefiveonetwoGrdTerm1New26
	})
	.component(typefiveonetwoGrdTerm2New26, {
		template: type_5_1_2_Term2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type5_1_2_grade_term2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type5_1_2_grade_term2_new26TemplateCtrl",
		controller: TypefiveonetwoGrdTerm2New26
	})
	.component(typefivethreefiveGrdTerm1New26, {
		template: type_5_3_5_Term1_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type5_3_5_grade_term1_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type5_3_5_grade_term1_new26TemplateCtrl",
		controller: TypefivethreefiveGrdTerm1New26
	})
	.component(typefivethreefiveGrdTerm2New26, {
		template: type_5_3_5_Term2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type5_3_5_grade_term2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type5_3_5_grade_term2_new26TemplateCtrl",
		controller: TypefivethreefiveGrdTerm2New26
	})
	.component(typesixsixsevenGrdTerm1New26, {
		template: type_6_6_7_Term1_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type6_6_7_grade_term1_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type6_6_7_grade_term1_new26TemplateCtrl",
		controller: TypesixsixsevenGrdTerm1New26
	})
	.component(typesixsixsevenGrdTerm2New26, {
		template: type_6_6_7_Term2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type6_6_7_grade_term2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type6_6_7_grade_term2_new26TemplateCtrl",
		controller: TypesixsixsevenGrdTerm2New26
	})
	.component(type8to10TermcbseNew26, {
		template: type_8_to_10_Termcbse_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type8to10_termcbse_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type8to10_termcbse_new26TemplateCtrl",
		controller: Type8to10TermcbseNew26
	})
	.component(type8to10Termcbseterm2New26, {
		template: type_8_to_10_Termcbseterm2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type8to10_termcbseterm2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type8to10_termcbseterm2_new26TemplateCtrl",
		controller: Type8to10Termcbseterm2New26
	})


	.component(type02Grade11ScienceNew26, {
		template: type_02_grade_11_science_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type02grade_11_science_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type02grade_11_science_new26TemplateCtrl",
		controller: Type02Grade11ScienceNew26
	})
	.component(type02Grade11Sciencet2New26, {
		template: type_02_grade_11_sciencet2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type02grade_11_sciencet2_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type02grade_11_sciencet2_new26TemplateCtrl",
		controller: Type02Grade11Sciencet2New26
	})
	.component(type02Grade12ScienceNew26, {
		template: type_02_grade_12_science_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type02grade_12_science_new26TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type02grade_12_science_new26TemplateCtrl",
		controller: Type02Grade12ScienceNew26
	})
	.component(type02Grade12Sciencet2New, {
		template: type_02_grade_12_sciencet2_new_template,
		transclude: true,
		bindings: true,
		require: {
			type02grade_12_sciencet2_new_TemplateCtrl: '^viewGeneratedReportData'
		},
		controllerAs: "type02grade_12_sciencet2_new_TemplateCtrl",
		controller: Type02Grade12Sciencet2New
	})
	.component(type10KbGradeTerm1New26, {
		template: type_10_KB_grade_term1_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type10KbGradeTerm1New26Ctrl: '^viewGeneratedReportData'
		},
		controllerAs: "type10KbGradeTerm1New26Ctrl",
		controller: Type10KbGradeTerm1New26
	})
	.component(type10KbGradeTerm2New26, {
		template: type_10_KB_grade_term2_new26_template,
		transclude: true,
		bindings: true,
		require: {
			type10KbGradeTerm2New26Ctrl: '^viewGeneratedReportData'
		},
		controllerAs: "type10KbGradeTerm2New26Ctrl",
		controller: Type10KbGradeTerm2New26
	})
    .constant('rcConstants', {
        _ggg: "jjj",
        _NOT_APPLICABLE: "NA",
        ABSENT: "ABSENT",
        TYPE_1_MARK: "type-1-mark",
        TYPE_1_DEFAULT_ANNUAL: "type-1-annual",
        TYPE_1_GRADE: "type-1-grade",
        TYPE_2_MARK: "type-2-mark",
        TYPE_SKILL_ONLY: "skill_only",
        TYPE_3_SUB_SLILL: "type-3-sub_skill",
        DEFAULT_PERIODICTEST_HF: "periodic-test-hf",
        DEFAULT_PERIODICTEST_ANNUAL: "periodic-test-annual",
        _CO_SCHOLASTIC_NAME: "Co-scholastic",
        GRADE_BASED_SUBJECT_PACKAGES: ['Co-scholastic'],
        DEFAULT_REPORTCARD_PT_HF_TWO: "Periodic Test-II-Half Yearly",
        DEFAULT_REPORTCARD_PT_ANNUAL_TWO: "Periodic Test-II-Annual",
        REPORT_CARDS_PERIODIC_TEST: ["Periodic Test-Half Yearly", "Periodic Test-II-Half Yearly", "Periodic Test-Annual", "Periodic Test-II-Annual"],
        DEFAULT_REPORTCARDS: ['Annual', 'Half Yearly', "Periodic Test-Half Yearly",
            "Periodic Test-Annual", "Periodic Test-II-Half Yearly", "Periodic Test-II-Annual"
        ],
        DEFAULT_ANUAL_REPORTCARD: 'Annual',
        DEFAULT_REPORTCARD_PT_ANNUAL: 'Periodic Test-Annual',
        DEFAULT_REPORTCARD_PT_HF: "Periodic Test-Half Yearly",
        DEFAULT_PERIODICTEST_HF_TWO: "periodic-test-hf-2",
        DEFAULT_PERIODICTEST_ANNUAL_TWO: "periodic-test-annual-two",
        DEFAULT_HF_REPORTCARD: 'Half Yearly',
        DEFAULT_REPORT_CARDS_FOR_YEAREND: ['Annual', 'Half Yearly'],
        DEFAULT_YEAR_END: "default-year-end",
        EDUCORE_YEAR_END: "educore-year-end",
        EVALUATION_RC: ["Evaluation-3", "Evaluation-2", "Evaluation-1"],
        EVAL_ONE_RC: "Evaluation-1",
        EVAL_TWO_RC: "Evaluation-2",
        EVAL_THREE_RC: "Evaluation-3",
        ASSET_ME_RC_HALF: ["Term 1"],
        ASSET_ME_RC_HALF_NAME: "Term 1",
        ASSET_ME_RC_ANNUAL_NAME: "Term 2",
        ASSET_ME_RC_NAMES: ["Term 1", "Term 2"],
        TYPE_4_MARK: "type-4-mark",
        TYPE_4_ANNUAL: "type-4-annual",
        ASSET_CONSOLIDATED: "term1-term2",
        KG_CARDS: ['KG-Term-1', 'KG-Term-2', 'KG-Term-3'],
        KB_CARDS: ['KB-Term-1', 'KB-Term-2', 'KB-Term-3'],
        KG_TERM: 'kg-term',
        KG_TERMS: 'kg-terms',
        KB_TERMS: 'kb-terms',
        KG_CONSOLIDATED: 'kg-consolidated',
        HIGHER_SECONDARY_REPORT: "hss-template",
        CBSE_HSHF: "cbse_hss",
        TERMONEHALF_YEARLY: "term1halfyearly",
        GRADE_9_ANNUAL: "grade-9-annual"
    })
    .controller('viewGeneratedReportData', reportGeneratedViewController);




// WEBPACK FOOTER //
// ./src/app/report_cards/teacher/viewModule.js